<template>
  <Teleport to="body">
    <div v-show="!hidden" class="fixed inset-0 z-[110] flex items-end justify-center" @click.self="$emit('close')">
      <div class="absolute inset-0 bg-black/50 backdrop-blur-[2px]" @click="$emit('close')" />

      <div class="relative w-full max-w-[430px] bg-cream shadow-2xl flex flex-col transition-all duration-300 photo-sheet"
           :class="[dialogExpanded ? 'photo-sheet-expanded' : 'rounded-t-3xl',
                    (loading && localItems.length === 0) ? 'photo-sheet-loading' : '']"
           :style="{ paddingTop: dialogExpanded ? 'var(--safe-top)' : '0px', fontFamily: 'Inter, sans-serif' }">

        <!-- Состояние загрузки (V3 ScanFrame) -->
        <template v-if="loading && localItems.length === 0">
          <div class="flex-1 flex flex-col" style="padding: 24px 24px 28px;">

            <!-- Фото с эффектом сканирования + заголовок -->
            <div class="flex-1 flex flex-col items-center justify-center" style="gap: 32px;">
              <!-- Фото-контейнер со сканом -->
              <div class="relative overflow-hidden" style="width: 220px; height: 220px; border-radius: 28px; box-shadow: 0 10px 30px rgba(0,0,0,0.10);">
                <img v-if="displayPhotoUrl" :src="imgUrl(displayPhotoUrl)" class="w-full h-full object-cover" />
                <!-- Голосовой ввод: фото нет, вместо него микрофон -->
                <div v-else-if="voice" class="w-full h-full bg-warm flex items-center justify-center">
                  <svg width="72" height="72" viewBox="0 0 24 24" fill="none" stroke="#FAF3E8" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="9" y="2" width="6" height="12" rx="3"/>
                    <path d="M5 11a7 7 0 0 0 14 0"/>
                    <line x1="12" y1="18" x2="12" y2="22"/>
                    <line x1="8.5" y1="22" x2="15.5" y2="22"/>
                  </svg>
                </div>
                <div class="scan-overlay" />
                <!-- Угловые маркеры -->
                <div class="scan-corner" style="top:12px;left:12px;border-top:2px solid rgba(255,255,255,0.9);border-left:2px solid rgba(255,255,255,0.9);" />
                <div class="scan-corner" style="top:12px;right:12px;border-top:2px solid rgba(255,255,255,0.9);border-right:2px solid rgba(255,255,255,0.9);" />
                <div class="scan-corner" style="bottom:12px;left:12px;border-bottom:2px solid rgba(255,255,255,0.9);border-left:2px solid rgba(255,255,255,0.9);" />
                <div class="scan-corner" style="bottom:12px;right:12px;border-bottom:2px solid rgba(255,255,255,0.9);border-right:2px solid rgba(255,255,255,0.9);" />
              </div>

              <!-- Заголовок + подзаголовок -->
              <div class="text-center">
                <p style="font-weight: 700; font-size: var(--fs-22); color: var(--ink); letter-spacing: -0.2px; margin-bottom: 6px;">Распознаю</p>
                <p style="font-size: var(--fs-13); color: var(--ink-70);">{{ voice ? 'Обычно 2–5 сек' : 'Обычно 3–15 сек' }}</p>
              </div>
            </div>

            <!-- Карточка совета (внизу) -->
            <div style="background: #FEEDB0; border-radius: 16px; padding: 14px 16px; height: 120px;"
                 class="flex items-start gap-3 shrink-0 overflow-hidden">
              <svg class="shrink-0 mt-0.5" width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 17V21.5C14 21.8978 13.842 22.2794 13.5607 22.5607C13.2794 22.842 12.8978 23 12.5 23H9.5C9.10218 23 8.72064 22.842 8.43934 22.5607C8.15804 22.2794 8 21.8978 8 21.5V17" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 20H14" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11 0.5V2" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M0.5 11H2" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2.75 3.5L3.85 4.56" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M21.5 11H20" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M19.2504 3.5L18.1504 4.56" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 10.5C8.39782 10.5 8.77936 10.658 9.06066 10.9393C9.34196 11.2206 9.5 11.6022 9.5 12V17" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.5 17V12C12.5 11.6022 12.658 11.2206 12.9393 10.9393C13.2206 10.658 13.6022 10.5 14 10.5" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7.92056 17H14.0806C15.1957 16.4476 16.132 15.5912 16.7814 14.5296C17.4307 13.468 17.7667 12.2444 17.7506 11C17.7197 9.21942 16.9987 7.52039 15.7394 6.26115C14.4802 5.0019 12.7811 4.28084 11.0006 4.25C9.21998 4.28084 7.52095 5.0019 6.2617 6.26115C5.00246 7.52039 4.2814 9.21942 4.25056 11C4.23439 12.2444 4.57037 13.468 5.21973 14.5296C5.8691 15.5912 6.80538 16.4476 7.92056 17Z" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div class="flex-1 relative" style="height: 100%;">
                <Transition name="tip-fade" mode="out-in">
                  <p :key="currentTipIndex" class="absolute inset-0" style="font-size: var(--fs-14); line-height: 1.45; color: var(--ink);">
                    <b>{{ tips[currentTipIndex % tips.length].title }}</b> {{ tips[currentTipIndex % tips.length].body }}
                  </p>
                </Transition>
              </div>
            </div>

          </div>
        </template>

        <!-- Основной контент -->
        <template v-else>

        <!-- Drag indicator + Заголовок + уверенность + крестик -->
        <div class="pt-3 px-5 pb-2 shrink-0">
          <div class="flex justify-center mb-3">
            <div class="w-10 h-1 rounded-full bg-[#D4C9B8]" />
          </div>
          <div class="flex items-center justify-between">
            <h2 style="font-family: Inter, sans-serif; font-size: var(--fs-16); font-weight: 400; color: var(--ink);">
              {{ mode === 'text' ? 'Добавить в дневник' : mode === 'photo' ? 'Распознаю' : mode === 'edit' ? 'Редактировать' : 'Добавить снова' }}
            </h2>
            <div class="flex items-center gap-2">
              <span
                v-if="mode === 'photo' && confidenceVal > 0"
                class="text-12 font-semibold px-3 py-1 rounded-full"
                :class="confidenceVal >= 70 ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'"
              >
                уверенность {{ confidenceVal }}%
              </span>
              <button @click="$emit('close')" class="w-8 h-8 flex items-center justify-center rounded-full text-ink active:bg-line transition-colors">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                  <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- Контент -->
        <!-- overscroll-contain именно здесь: прокручивается этот блок, а не лист.
             Без него, когда прокрутка дошла до края, жест утаскивает за собой
             страницу под окном, и содержимое пружинит вместо прокрутки. -->
        <div ref="dialogContentRef" @scroll="onDialogScroll"
             class="flex-1 overflow-y-auto overscroll-contain px-5 photo-content-appear">

          <!-- ═══ Время приёма (тап — попап даты/времени и повтора) ═══ -->
          <button @click.stop="showTimePopup = true"
                  class="flex items-center gap-1.5 rounded-lg px-2 py-1 active:bg-[#F5F0E8] transition-colors"
                  :class="repeatIndicator ? 'mb-0.5' : 'mb-2'"
                  style="font-family: Inter, sans-serif;">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#8B7B6B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>
            </svg>
            <span style="font-size: var(--fs-14); color: var(--ink-70);">{{ mealTimeLabel }}</span>
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#C4B8A8" stroke-width="2.5" stroke-linecap="round"><path d="M9 6l6 6-6 6"/></svg>
          </button>

          <!-- Явное указание повтора: что ещё будет продублировано (или откуда
               это блюдо скопировано). Отдельной строкой под временем — «· повтор»
               без расшифровки не отвечал на вопрос «на какие даты?» -->
          <button v-if="repeatIndicator" @click.stop="showTimePopup = true"
                  class="flex items-center gap-1.5 mb-2 rounded-lg px-2 py-0.5 active:bg-[#F5F0E8] transition-colors"
                  style="font-family: Inter, sans-serif;">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#B98A5E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17 2l4 4-4 4"/><path d="M3 11v-1a4 4 0 0 1 4-4h14"/>
              <path d="M7 22l-4-4 4-4"/><path d="M21 13v1a4 4 0 0 1-4 4H3"/>
            </svg>
            <span style="font-size: var(--fs-14); color: var(--warm);">{{ repeatIndicator }}</span>
          </button>

          <!-- ═══ Название блюда (над фото, полная ширина). Шрифт 20px —
               заголовок должен читаться крупнее строки времени над ним ═══ -->
          <div v-if="dishName || editingDishName" class="mb-3">
            <template v-if="editingDishName">
              <input
                ref="dishNameInputRef"
                v-model="dishName"
                @blur="editingDishName = false"
                @keydown.enter="editingDishName = false"
                class="w-full bg-white rounded-lg px-2 py-1 border-b border-t-0 border-x-0 border-[#C4B8A8] outline-none"
                style="font-family: Inter, sans-serif; font-size: var(--fs-20); font-weight: 700; color: var(--ink); letter-spacing: -0.2px;"
              />
            </template>
            <template v-else>
              <button @click.stop="startEditDishName"
                      class="text-left rounded-lg bg-white px-2 py-1 active:bg-[#F5F0E8] transition-colors"
                      style="font-family: Inter, sans-serif; font-size: var(--fs-20); font-weight: 700; color: var(--ink); letter-spacing: -0.2px; line-height: 1.2;">
                {{ dishName }}
              </button>
            </template>
          </div>

          <!-- Теги — у любого блюда и продукта, не только с сердечком:
               по ним фильтруются и «Рецепты», и «Ранее» -->
          <DishTagsEditor :model-value="dishTags" @update:model-value="onDishTagsInput" class="mb-3" />

          <!-- ═══ Фото + КБЖУ (горизонтальная раскладка) ═══ -->
          <div class="flex gap-3 mb-4">
            <!-- Фото слева -->
            <div v-if="mode !== 'text'" class="shrink-0" style="width: 150px;">
              <div class="relative" @click="mode === 'edit' ? openPhotoMenu() : null"
                   :class="mode === 'edit' ? 'cursor-pointer' : ''">
                <img
                  v-if="displayPhotoUrl"
                  :src="imgUrl(displayPhotoUrl)"
                  alt=""
                  class="w-full rounded-2xl object-cover"
                  style="aspect-ratio: 1/1.1;"
                />
                <!-- Без фото, но с иконками продуктов (лента, lib/foodIcons.js):
                     та же сетка, что в карточке; подсказка «Добавить фото» в
                     режиме правки остаётся поверх -->
                <div
                  v-else-if="icons.length"
                  class="w-full rounded-2xl bg-warm icon-grid"
                  :class="'n' + icons.length"
                  style="aspect-ratio: 1/1.1;"
                >
                  <img v-for="k in icons" :key="k" :src="imgUrl('/food-icons/' + k + '.webp')" alt="" />
                </div>
                <div
                  v-else
                  class="w-full rounded-2xl bg-warm flex items-center justify-center"
                  style="aspect-ratio: 1/1.1;"
                >
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#FAF3E8" stroke-width="1.5" stroke-linecap="round">
                    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
                    <circle cx="12" cy="13" r="4"/>
                  </svg>
                </div>

                <!-- Подсказка «добавить / заменить фото» в edit-режиме -->
                <div v-if="mode === 'edit'"
                     class="absolute bottom-2 left-2 right-2
                            bg-ink/40 backdrop-blur-sm rounded-full
                            text-center flex items-center justify-center"
                     style="padding-top: 5px; padding-bottom: 5px;">
                  <span class="text-white text-12 leading-none" style="font-family: Inter, sans-serif;">{{ displayPhotoUrl ? 'Заменить фото' : 'Добавить фото' }}</span>
                </div>

                <!-- Сердечко — избранное -->
                <button
                  @click.stop="toggleFavorite"
                  class="absolute top-2 right-2 w-7 h-7 rounded-full bg-black/20 backdrop-blur-sm flex items-center justify-center active:scale-90 transition-transform"
                >
                  <svg width="14" height="12" viewBox="0 0 24 20" :fill="isFavorite ? '#FF6B6B' : 'none'" :stroke="isFavorite ? '#FF6B6B' : 'white'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M13.8131 18.2326C12.5923 19.442 10.7015 19.442 9.48071 18.2326L2.19973 11.019C-2.67113 6.14805 3.68934 -4.6136 11.6469 3.34396C19.5905 -4.59961 25.951 6.16221 21.0941 11.019L13.8131 18.2326Z"/>
                  </svg>
                </button>
                <!-- Иконка рецепта -->
                <div
                  v-if="isPortionMode"
                  class="absolute bottom-2 right-2 w-7 h-7 rounded-full bg-black/20 backdrop-blur-sm flex items-center justify-center"
                >
                  <svg width="14" height="12" viewBox="0 0 14 12" fill="none" stroke="#FAF3E8" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M7 2C8.72391 2 10.3772 2.68482 11.5962 3.90381C12.8152 5.12279 13.5 6.77609 13.5 8.5C13.5 8.76522 13.3946 9.0196 13.2071 9.2071C13.0196 9.3946 12.7652 9.5 12.5 9.5H1.5C1.23478 9.5 0.98043 9.3946 0.792893 9.2071C0.605357 9.0196 0.5 8.76522 0.5 8.5C0.5 6.77609 1.18482 5.12279 2.40381 3.90381C3.62279 2.68482 5.27609 2 7 2Z"/>
                    <path d="M7 2V0.5"/>
                    <path d="M0.5 11.5H13.5"/>
                  </svg>
                </div>
              </div>

              <!-- Пояснение и сброс — только для карточки из одного продукта базы -->
              <template v-if="mode === 'edit' && singleProductId">
                <p v-if="editPhotoBase64 || productPhotoCustom"
                   class="text-11 leading-tight mt-1.5"
                   style="font-family: Inter, sans-serif; color: var(--ink-70);">
                  Это фото продукта — оно ваше и видно только вам
                </p>
                <button
                  v-if="productPhotoCustom && !editPhotoBase64 && !resetProductPhoto"
                  @click.stop="resetProductPhoto = true"
                  class="text-11 leading-tight mt-1 underline active:opacity-60"
                  style="font-family: Inter, sans-serif; color: var(--ink-70);"
                >Вернуть фото из базы</button>
                <p v-if="resetProductPhoto"
                   class="text-11 leading-tight mt-1"
                   style="font-family: Inter, sans-serif; color: var(--ink-70);">
                  Фото из базы вернётся после сохранения
                </p>
              </template>
            </div>

            <!-- КБЖУ справа от фото -->
            <div v-if="anyKbjuVisible" class="flex-1 min-w-0 flex flex-col justify-center">
              <!-- Порция -->
              <p style="font-family: Inter, sans-serif; font-size: var(--fs-16); font-weight: 400; color: var(--ink);" class="mb-2">
                На порцию:
              </p>

              <!-- Пилюли КБЖУ -->
              <div class="flex flex-col gap-1 items-start">
                <template v-if="isEnriching">
                  <div v-if="showKcal" class="flex items-center gap-2">
                    <span class="pill-kcal text-12 font-medium flex items-center gap-1"><span class="inline-block w-2.5 h-2.5 border border-ink/40 border-t-[#41291A] rounded-full animate-spin" /></span>
                    <span class="text-13 text-ink">Ккал</span>
                  </div>
                  <div v-if="showProtein" class="flex items-center gap-2">
                    <span class="pill-protein text-12 flex items-center gap-1"><span class="inline-block w-2.5 h-2.5 border border-ink/40 border-t-[#41291A] rounded-full animate-spin" /></span>
                    <span class="text-13 text-ink">Белки</span>
                  </div>
                  <div v-if="showFat" class="flex items-center gap-2">
                    <span class="pill-fat text-12 flex items-center gap-1"><span class="inline-block w-2.5 h-2.5 border border-ink/40 border-t-[#41291A] rounded-full animate-spin" /></span>
                    <span class="text-13 text-ink">Жиры</span>
                  </div>
                  <div v-if="showCarbs" class="flex items-center gap-2">
                    <span class="pill-carbs text-12 flex items-center gap-1"><span class="inline-block w-2.5 h-2.5 border border-ink/40 border-t-[#41291A] rounded-full animate-spin" /></span>
                    <span class="text-13 text-ink">Углеводы</span>
                  </div>
                  <div v-if="showFiber" class="flex items-center gap-2">
                    <span class="pill-fiber text-12 flex items-center gap-1"><span class="inline-block w-2.5 h-2.5 border border-ink/40 border-t-[#41291A] rounded-full animate-spin" /></span>
                    <span class="text-13 text-ink">Клетчатка</span>
                  </div>
                </template>
                <template v-else>
                  <div v-if="showKcal" class="flex items-center gap-2">
                    <span class="pill-kcal text-12 font-medium" style="min-width: 36px; text-align: center;">{{ totalKcal }}</span>
                    <span class="text-13 text-ink">Ккал</span>
                  </div>
                  <div v-if="showProtein" class="flex items-center gap-2">
                    <span class="pill-protein text-12 font-medium" style="min-width: 36px; text-align: center;">{{ totalProtein }}</span>
                    <span class="text-13 text-ink">Белки</span>
                  </div>
                  <div v-if="showFat" class="flex items-center gap-2">
                    <span class="pill-fat text-12 font-medium" style="min-width: 36px; text-align: center;">{{ totalFat }}</span>
                    <span class="text-13 text-ink">Жиры</span>
                  </div>
                  <div v-if="showCarbs" class="flex items-center gap-2">
                    <span class="pill-carbs text-12 font-medium" style="min-width: 36px; text-align: center;">{{ totalCarbs }}</span>
                    <span class="text-13 text-ink">Углеводы</span>
                  </div>
                  <div v-if="showFiber" class="flex items-center gap-2">
                    <span class="pill-fiber text-12 font-medium" style="min-width: 36px; text-align: center;">{{ totalFiber }}</span>
                    <span class="text-13 text-ink">Клетчатка</span>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <!-- ═══ Состав: Заголовок ═══ -->
          <p style="font-family: Inter, sans-serif; font-size: var(--fs-16); font-weight: 400; color: var(--ink);" class="mb-0">Состав:</p>

          <!-- ═══ Список ингредиентов ═══ -->
          <div class="flex flex-col">
            <div
              v-for="(item, i) in localItems"
              :key="i"
            >
              <!-- ── Обёртка item: обычная строка ИЛИ мини-карточка ── -->
              <div
                :class="[
                  expandedIngIdx === i
                    ? 'rounded-2xl bg-white shadow-sm ing-card-enter -mx-3'
                    : 'border-b border-[#EDE5D8]'
                ]"
                :style="expandedIngIdx === i ? 'border: 1px solid #EDE5D8;' : ''"
              >
                <!-- Строка item (всегда видна) -->
                <div class="flex items-center gap-2 pt-[8px] pb-[6px]"
                     :class="expandedIngIdx === i ? 'px-[11px] pt-3' : ''">
                  <button
                    @click="toggleIngredientCard(i)"
                    class="flex-1 text-left min-w-0"
                  >
                    <span class="text-15 font-semibold leading-tight"
                      :class="isUnresolved(item) ? 'text-error' : 'text-ink'"
                    >{{ item.name }}</span>
                    <span v-if="getItemSourceBadge(item)" class="inline-flex items-center align-middle ml-1">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="7" fill="#D6ECCE"/><path d="M4.375 7.5L6.25 9.375L9.625 5.625" stroke="#3F6E2B" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    </span>
                    <span v-if="item._usedFallback" class="inline-flex items-center align-middle ml-1 text-9 font-semibold px-1.5 py-0.5 rounded-full bg-ai-bg text-ai">ИИ</span>
                  </button>

                  <!-- Флаг — коррекция продукта (только для найденных по штрихкоду) -->
                  <button
                    v-if="item._submitted && item.product_id && item.barcode"
                    @click.stop="openCorrectionDialog(i)"
                    class="shrink-0 w-7 h-7 flex items-center justify-center rounded-lg text-ink/70 active:bg-[#E0D9CF] transition-colors"
                    title="Исправить данные"
                  >
                    <svg width="14" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/>
                      <line x1="4" y1="22" x2="4" y2="15"/>
                    </svg>
                  </button>

                  <!-- В чём считать: штуки или граммы — только у продуктов из набора
                       BUILTIN_UNITS; стоит слева от цифры (решение владельца 26.10.2026) -->
                  <button
                    v-if="showWeight && (item._unit?.kind === 'builtin' || matchBuiltin(item.name || item.db_name))"
                    @click.stop="openUnitSheet(i)"
                    class="shrink-0 w-6 h-7 -mr-1 flex items-center justify-center rounded-lg text-ink/60 active:bg-[#E0D9CF]"
                    title="В чём считать"
                  >
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M6 9l6 6 6-6"/></svg>
                  </button>
                  <button
                    v-if="showWeight"
                    :data-guide="i === 0 ? 'weight' : null"
                    @click.stop="editWeight(i, item._unit ? 'qty' : 'g')"
                    class="shrink-0 rounded-lg bg-white px-2.5 py-1 flex items-center gap-1"
                  >
                    <template v-if="editingIdx === i">
                      <input
                        ref="weightInputRef"
                        :value="editField === 'qty' ? item.qty : item.weight_g"
                        @input="onWeightFieldInput(item, $event.target.value)"
                        type="text"
                        inputmode="decimal"
                        class="w-10 text-center text-15 font-bold text-ink bg-white rounded py-0.5 outline-none border-0"
                        @blur="finishEditWeight(item)"
                        @keydown.enter="$event.target.blur()"
                      />
                      <span class="text-13 text-ink/70">{{ editField === 'qty' ? item._unit.name : 'г' }}</span>
                    </template>
                    <!-- Штуки и порции: «2 шт · 106 г». Тап по числу правит штуки,
                         тап по граммам — граммы; второе поле пересчитывается. -->
                    <template v-else-if="item._unit">
                      <span class="text-15 font-semibold text-ink">{{ fmtQty(item.qty) }}</span>
                      <span class="text-13 text-ink/70">{{ item._unit.name }}</span>
                      <span class="text-13 text-ink/70 pl-1" @click.stop="editWeight(i, 'g')">· {{ Math.round(item.weight_g) }} г</span>
                    </template>
                    <template v-else>
                      <span class="text-15 font-semibold text-ink">{{ item.weight_g }}</span>
                      <span class="text-13 text-ink/70">г</span>
                    </template>
                  </button>
                </div>

                <!-- Крупа или паста: сухая запись и вода, из которых собран вес -->
                <div v-if="item._grainParts && item._grainParts.length > 1"
                     @click="toggleIngredientCard(i)"
                     class="text-13 text-ink/70 leading-tight pt-0 pb-[6px] cursor-pointer"
                     :class="expandedIngIdx === i ? 'px-[11px]' : 'pl-1'">
                  <p v-for="(part, pi) in item._grainParts" :key="pi" class="flex gap-1.5 items-baseline">
                    <span class="w-[9px] shrink-0">{{ pi === 0 ? '→' : '+' }}</span>
                    <span class="flex-1 min-w-0 truncate">{{ part.db_name }}</span>
                    <span class="shrink-0 tabular-nums">{{ part.weight_g }} г</span>
                  </p>
                </div>

                <!-- db_name. У крупы не показываем: её раскладка выше уже назвала
                     сухую запись, и строка «→ Макароны из муки высшего сорта»
                     повторяла бы её. Раньше это выражал v-else-if от блока
                     переключателя вида веса, теперь условие стоит явно. -->
                <p v-if="!item._grain && (item.type === 'direct' || item.type === 'package') && item.db_name && item.db_name !== item.name"
                   @click="toggleIngredientCard(i)"
                   class="text-13 text-ink/70 leading-tight pt-0 pb-[6px] cursor-pointer"
                   :class="expandedIngIdx === i ? 'px-[11px]' : 'pl-1'">
                  → {{ item.db_name }}
                </p>
                <!-- Ужарка: вес на тарелке готовый, карточка сырая, считаем от сырого -->
                <p v-if="item._cooking && item.type === 'direct'"
                   @click="toggleIngredientCard(i)"
                   class="text-11 text-ink/60 leading-tight pt-0 pb-[6px] cursor-pointer"
                   :class="expandedIngIdx === i ? 'px-[11px]' : 'pl-1'">
                  {{ cookingHint(item._cooking) }}
                </p>
                <p v-if="item.type === 'direct' && !item.db_name && item.matched === false && !item._usedFallback"
                   class="text-11 text-ink/70 pt-0.5"
                   :class="expandedIngIdx === i ? 'px-[11px]' : 'pl-1'">
                  Не найден в базе
                </p>

                <!-- Подбор КБЖУ не дошёл до сервера: без этого блюдо молча
                     уезжало в дневник с нулями и красным составом -->
                <div v-if="item._enrichFailed"
                     class="flex items-center gap-2 flex-wrap pt-0.5 pb-1"
                     :class="expandedIngIdx === i ? 'px-[11px]' : 'pl-1'">
                  <span class="text-11 text-error leading-tight">КБЖУ не подобрались: нет связи с сервером</span>
                  <button
                    @click.stop="retryEnrich(i)"
                    :disabled="retryingIdx === i"
                    class="text-12 text-ai bg-ai-bg px-2.5 py-1 rounded-full disabled:opacity-50"
                  >
                    {{ retryingIdx === i ? 'Повторяю…' : 'Повторить' }}
                  </button>
                </div>

                <!-- Кнопка "Добавить в базу" для package -->
                <button
                  v-if="item.type === 'package' && item.matched === false && item._hasLabelData && !item._submitted"
                  @click="openLabelReview(i)"
                  class="text-12 text-[#2D6A4F] bg-[#D4EDDA] px-2.5 py-1 rounded-full mt-1 inline-block"
                  :class="expandedIngIdx === i ? 'ml-[11px]' : ''"
                >
                  Добавить в базу
                </button>

                <!-- Кнопка "Сфотографировать этикетку" -->
                <button
                  v-if="(item.type === 'package' || item.type === 'direct') && item.matched === false && !item._hasLabelData && !item._submitted && item._usedFallback"
                  @click="openLabelReview(i)"
                  class="text-12 text-ai bg-ai-bg px-2.5 py-1 rounded-full mt-1 inline-block"
                  :class="expandedIngIdx === i ? 'ml-[11px]' : ''"
                >
                  Сфотографировать этикетку
                </button>

                <!-- ═══ Раскрытая часть мини-карточки (КБЖУ + кнопки) ═══ -->
                <div
                  v-if="expandedIngIdx === i"
                  class="px-[11px] pb-3 pt-0.5 ing-card-content"
                >
                  <div v-if="anyKbjuVisible" class="flex flex-wrap gap-1.5 mb-3">
                    <span v-if="showKcal" class="pill-kcal text-12 font-medium">{{ Math.round(item.kcal || 0) }}</span>
                    <span v-if="showProtein" class="pill-protein text-12 font-medium">{{ fmtMacro(item.protein) }}</span>
                    <span v-if="showFat" class="pill-fat text-12 font-medium">{{ fmtMacro(item.fat) }}</span>
                    <span v-if="showCarbs" class="pill-carbs text-12 font-medium">{{ fmtMacro(item.carbs) }}</span>
                  </div>

                  <div class="flex gap-2">
                    <button
                      v-if="item.type === 'direct' || item.type === 'package'"
                      @click="openProductDetails(i)"
                      :disabled="!item.product_id"
                      class="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl bg-[#F5F0E8] text-15 font-semibold text-ink active:scale-[0.97] transition-transform disabled:opacity-40 disabled:active:scale-100"
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>
                      </svg>
                      Подробнее
                    </button>
                    <button
                      @click="openSearchForItem(i)"
                      class="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl bg-[#F5F0E8] text-15 font-semibold text-ink active:scale-[0.97] transition-transform"
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/>
                        <polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/>
                      </svg>
                      Заменить
                    </button>
                    <button
                      @click="removeItem(i)"
                      class="shrink-0 w-11 flex items-center justify-center py-2 rounded-xl bg-kcal/30 text-error active:scale-[0.97] transition-transform"
                    >
                      <svg width="16" height="17" viewBox="0 0 13 14" fill="none">
                        <path d="M0.5 3.5H12.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2 3.5H11V12.5C11 12.7652 10.8946 13.0196 10.7071 13.2071C10.5196 13.3946 10.2652 13.5 10 13.5H3C2.73478 13.5 2.48043 13.3946 2.29289 13.2071C2.10536 13.0196 2 12.7652 2 12.5V3.5Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M4 3.5V3C4 2.33696 4.26339 1.70107 4.73223 1.23223C5.20107 0.763392 5.83696 0.5 6.5 0.5C7.16304 0.5 7.79893 0.763392 8.26777 1.23223C8.73661 1.70107 9 2.33696 9 3V3.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5 6.50098V10.5025" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8 6.50098V10.5025" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              <!-- ═══ Ингредиенты блюда (из Gemini или рецепта) — НЕ для direct/package ═══ -->
              <div
                v-if="item.type !== 'direct' && item.type !== 'package' && getIngredients(item, i)"
                class="flex flex-col"
              >
                <div
                  v-for="(ing, j) in getIngredients(item, i)"
                  :key="j"
                >
                  <!-- Обёртка: обычная строка ИЛИ мини-карточка (ингредиент внутри) -->
                  <div
                    :class="[
                      expandedSubIngIdx === `${i}-${j}`
                        ? 'rounded-2xl bg-white shadow-sm ing-card-enter -mx-3'
                        : 'border-b border-[#EDE5D8]'
                    ]"
                    :style="expandedSubIngIdx === `${i}-${j}` ? 'border: 1px solid #EDE5D8;' : ''"
                  >
                    <!-- Строка ингредиента (всегда видна, одинаковые отступы) -->
                    <div class="flex items-center gap-2 pl-4 pr-0 pt-[6px] pb-[6px]"
                         :class="expandedSubIngIdx === `${i}-${j}` ? 'pl-[27px] pr-[11px] pt-3' : ''">
                      <button
                        @click="toggleSubIngredientCard(i, j)"
                        class="flex-1 text-left min-w-0"
                      >
                        <span class="text-15 leading-tight"
                          :class="ing.matched === false ? 'text-error' : 'text-ink'"
                        >{{ ing.name }}</span>
                        <span v-if="getIngSourceBadge(ing)" class="inline-flex items-center align-middle ml-1">
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><circle cx="7" cy="7" r="7" fill="#D6ECCE"/><path d="M4.375 7.5L6.25 9.375L9.625 5.625" stroke="#3F6E2B" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        </span>
                      </button>

                      <button
                        v-if="showWeight"
                        @click.stop="editIngWeight(i, j)"
                        class="shrink-0 rounded-lg bg-white px-2 py-0.5 flex items-center gap-1"
                      >
                        <template v-if="editingIngIdx === `${i}-${j}`">
                          <input
                            ref="ingWeightInputRef"
                            :value="ing.weight_g"
                            @input="ing.weight_g = parseDecimal($event.target.value)"
                            type="text"
                            inputmode="decimal"
                            class="w-8 text-center text-15 font-bold text-ink bg-white rounded py-0.5 outline-none border-0"
                            @blur="finishEditIngWeight(item, i)"
                            @keydown.enter="finishEditIngWeight(item, i); editingIngIdx = ''"
                          />
                        </template>
                        <template v-else>
                          <span class="text-15 font-semibold text-ink">{{ ing.weight_g }}</span>
                          <span class="text-13 text-ink/70">г</span>
                        </template>
                      </button>
                    </div>

                    <!-- db_name; для крупы отдельной строкой — сколько сухой внутри.
                         Флекс, чтобы вторая строка встала под названием, а не под стрелкой -->
                    <div v-if="ing.db_name && ing.db_name !== ing.name"
                         @click="toggleSubIngredientCard(i, j)"
                         class="text-13 text-ink/70 leading-tight pl-5 pt-0 pb-[6px] cursor-pointer flex gap-1"
                         :class="expandedSubIngIdx === `${i}-${j}` ? 'pl-[27px] pr-[11px]' : ''">
                      <span class="shrink-0">→</span>
                      <span class="min-w-0">
                        {{ ing.db_name }}
                        <!-- Раскладка крупы: у позиции она показана двумя строками
                             с названиями продуктов, здесь места меньше, поэтому
                             одной строкой — но с водой, иначе непонятно, почему
                             35 г макарон весят как 14,6. -->
                        <span v-if="ing._grain?.basis === 'cooked'" class="block">{{ fmtG(ing._grain.dry_weight_g) }} г сухих<template v-if="ing._grain.water_weight_g > 0"> + {{ fmtG(ing._grain.water_weight_g) }} г воды</template></span>
                        <!-- Ужарка: вес готовый, карточка сырая (lib/cooking.js) -->
                        <span v-if="ing._cooking" class="block">{{ cookingHint(ing._cooking) }}</span>
                      </span>
                    </div>

                    <!-- ═══ Раскрытая часть мини-карточки (КБЖУ + кнопки) ═══ -->
                    <div
                      v-if="expandedSubIngIdx === `${i}-${j}`"
                      class="px-[11px] pb-3 pt-0.5 ing-card-content"
                    >
                      <div v-if="anyKbjuVisible" class="flex flex-wrap gap-1.5 mb-3">
                        <span v-if="showKcal" class="pill-kcal text-12 font-medium">{{ Math.round((ing.per100?.kcal || 0) * (ing.weight_g || 0) / 100) }}</span>
                        <span v-if="showProtein" class="pill-protein text-12 font-medium">{{ fmtMacro((ing.per100?.protein || 0) * (ing.weight_g || 0) / 100) }}</span>
                        <span v-if="showFat" class="pill-fat text-12 font-medium">{{ fmtMacro((ing.per100?.fat || 0) * (ing.weight_g || 0) / 100) }}</span>
                        <span v-if="showCarbs" class="pill-carbs text-12 font-medium">{{ fmtMacro((ing.per100?.carbs || 0) * (ing.weight_g || 0) / 100) }}</span>
                      </div>
                      <div class="flex gap-2">
                        <button
                          @click="openSubIngProductDetails(i, j)"
                          :disabled="!ing.product_id"
                          class="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl bg-[#F5F0E8] text-15 font-semibold text-ink active:scale-[0.97] transition-transform disabled:opacity-40 disabled:active:scale-100"
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>
                          </svg>
                          Подробнее
                        </button>
                        <button
                          @click="openSearchForIngredient(i, j)"
                          class="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl bg-[#F5F0E8] text-15 font-semibold text-ink active:scale-[0.97] transition-transform"
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/>
                            <polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/>
                          </svg>
                          Заменить
                        </button>
                        <button
                          @click="removeIngredient(i, j)"
                          class="shrink-0 w-11 flex items-center justify-center py-2 rounded-xl bg-kcal/30 text-error active:scale-[0.97] transition-transform"
                        >
                          <svg width="16" height="17" viewBox="0 0 13 14" fill="none">
                            <path d="M0.5 3.5H12.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M2 3.5H11V12.5C11 12.7652 10.8946 13.0196 10.7071 13.2071C10.5196 13.3946 10.2652 13.5 10 13.5H3C2.73478 13.5 2.48043 13.3946 2.29289 13.2071C2.10536 13.0196 2 12.7652 2 12.5V3.5Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M4 3.5V3C4 2.33696 4.26339 1.70107 4.73223 1.23223C5.20107 0.763392 5.83696 0.5 6.5 0.5C7.16304 0.5 7.79893 0.763392 8.26777 1.23223C8.73661 1.70107 9 2.33696 9 3V3.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M5 6.50098V10.5025" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M8 6.50098V10.5025" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- ═══ Кнопка "+ Добавить продукт" ═══ -->
            <button
              @click="openAddProduct"
              class="flex items-center gap-2 py-3 text-15 font-semibold text-ink active:text-ink/70 transition-colors"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" rx="12" fill="#41291A" fill-opacity="0.15"/>
                <path d="M12.0007 8.20801V15.7913M8.20898 11.9997H15.7923" stroke="#41291A" stroke-width="1.19167" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Добавить продукт
            </button>
          </div>

          <!-- Голосовой ввод: что услышала модель — чтобы ошибку было видно сразу -->
          <div v-if="voice && voiceTranscript" class="rounded-2xl bg-white px-4 py-3 mb-2 mt-2">
            <p class="text-12 text-ink/70 mb-0.5">Я услышала</p>
            <p class="text-14 text-ink" style="line-height: 1.4;">«{{ voiceTranscript }}»</p>
          </div>

          <!-- Поле корректировки ИИ -->
          <div v-if="mode !== 'text' && mode !== 'edit' && mode !== 'repeat'" class="relative rounded-2xl mb-4 mt-2" style="background: #FEEDB0;">
            <textarea
              v-model="correction"
              rows="2"
              placeholder="Напишите, что добавить или заменить и Зоя внесёт правки"
              class="w-full py-3 px-4 pr-10 rounded-2xl text-14 text-ink outline-none border-0 resize-none yellow-placeholder"
              style="background: #FEEDB0; font-family: Inter, sans-serif;"
            />
            <button
              v-if="correction.trim()"
              @click="sendCorrection"
              :disabled="refining"
              class="absolute right-3 bottom-3 text-ink/70 hover:text-ink disabled:opacity-40"
            >
              <svg v-if="!refining" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="22" y1="2" x2="11" y2="13"/>
                <polygon points="22 2 15 22 11 13 2 9 22 2"/>
              </svg>
              <div v-else class="w-5 h-5 border-2 border-[#C4B8A8] border-t-[#41291A] rounded-full animate-spin" />
            </button>
          </div>

          <!-- AI disclaimer -->
          <p v-if="mode !== 'text' && mode !== 'edit'" class="text-11 text-center px-4 mb-3" style="color: var(--ink-70);">
            Состав и вес блюда определены ИИ и могут отличаться от фактических. Нутриенты рассчитаны по базам данных.
          </p>

        </div>

        <!-- Вес порции (для edited блюд при повторном добавлении) -->
        <div v-if="isPortionMode && showWeight" class="px-5 pt-2 pb-1 shrink-0">
          <!-- Порций: рецепт с «порций на рецепт» повторяется порциями,
               граммы под ним пересчитываются и остаются редактируемыми -->
          <div v-if="portionG" class="flex items-center justify-between bg-white rounded-2xl px-4 py-3 mb-2">
            <span class="text-15 font-semibold text-ink">Порций <span class="text-13 font-normal text-ink/70">· 1 порция ≈ {{ Math.round(portionG) }} г</span></span>
            <div class="flex items-center gap-1">
              <button @click="stepPortions(-1)" class="w-8 h-8 rounded-lg bg-[#F5F0E8] text-ink text-18 font-semibold active:bg-line">−</button>
              <span class="w-10 text-center text-16 font-bold text-ink">{{ fmtQty(portionsQty) }}</span>
              <button @click="stepPortions(1)" class="w-8 h-8 rounded-lg bg-[#F5F0E8] text-ink text-18 font-semibold active:bg-line">+</button>
            </div>
          </div>
          <div class="flex items-center justify-between bg-white rounded-2xl px-4 py-3">
            <span class="text-15 font-semibold text-ink">Вес порции</span>
            <div class="flex items-center gap-1">
              <template v-if="editingPortionWeight">
                <input
                  ref="portionWeightInputRef"
                  :value="portionWeightStr"
                  @input="onPortionWeightInput"
                  type="text"
                  inputmode="decimal"
                  class="w-16 text-center text-16 font-bold text-ink bg-[#F5F0E8] rounded-lg py-1 outline-none border-0 hide-spin"
                  @blur="finishEditPortionWeight"
                  @keydown.enter="finishEditPortionWeight"
                />
              </template>
              <template v-else>
                <button
                  @click="startEditPortionWeight"
                  class="text-16 font-bold text-ink px-2 py-1 rounded-lg active:bg-[#F5F0E8] transition-colors"
                >
                  {{ portionWeight }} г
                </button>
              </template>
            </div>
          </div>
          <p v-if="portionWeightError" class="text-xs text-red-600 mt-1.5 px-1">{{ portionWeightError }}</p>
        </div>

        <!-- Кнопки -->
        <div class="px-5 pb-8 pt-2 flex flex-col gap-3 shrink-0">
          <div v-if="zeroWarnItems.length" class="rounded-2xl bg-ai-bg px-4 py-3 text-13 text-ai leading-snug">
            <p>Без КБЖУ: «{{ zeroWarnItems.join('», «') }}». Подбор продуктов не дошёл до сервера.</p>
            <div class="flex gap-2 mt-2">
              <button @click="retryAllFailed" class="flex-1 py-2 rounded-xl bg-ink text-cream text-13 font-semibold">Повторить подбор</button>
              <button @click="addAll(true)" class="flex-1 py-2 rounded-xl bg-white text-ai text-13 font-semibold">Сохранить с нулями</button>
            </div>
          </div>
          <p v-if="saveError" class="text-13 text-red-600 text-center leading-snug px-1">{{ saveError }}</p>
          <button
            @click="addAll()"
            :disabled="addingAll || isEnriching || localItems.length === 0 || !hasChanges"
            class="w-full py-3.5 rounded-2xl bg-ink text-cream text-16 font-semibold
                   disabled:opacity-40 active:scale-[0.98] transition-all flex items-center justify-center gap-2"
          >
            <span v-if="isEnriching" class="inline-block w-4 h-4 border-2 border-cream/40 border-t-[#FAF3E8] rounded-full animate-spin" />
            {{ addingAll ? (slowSave ? 'Сохраняю… связь медленная' : 'Сохраняю...') : isEnriching ? 'Загружаю данные...' : netOffline ? 'Нет связи' : mode === 'edit' ? 'Сохранить изменения' : 'Добавить в Дневник' }}
          </button>
          <button
            v-if="mode === 'edit'"
            @click="deleteDish"
            :disabled="deletingDish"
            class="w-full py-3 rounded-2xl bg-white text-error text-15 font-semibold
                   disabled:opacity-40 active:scale-[0.98] transition-all"
          >
            {{ deletingDish ? 'Удаляю...' : 'Удалить' }}
          </button>
          <button
            v-if="mode !== 'edit'"
            @click="$emit('close')"
            class="w-full py-3 rounded-2xl bg-white text-ink text-15 font-semibold"
          >
            Отмена
          </button>
        </div>

        </template>

      </div>
    <UnitSheet
    v-if="unitSheetIdx >= 0 && localItems[unitSheetIdx]"
    :title="localItems[unitSheetIdx].name"
    :product-id="localItems[unitSheetIdx].product_id ? Number(localItems[unitSheetIdx].product_id) : null"
    :unit="localItems[unitSheetIdx]._unit || null"
    :builtin-key="matchBuiltin(localItems[unitSheetIdx].name || localItems[unitSheetIdx].db_name)"
    :weight-g="Number(localItems[unitSheetIdx].weight_g) || 0"
    @select="onUnitSelected"
    @close="unitSheetIdx = -1"
  />
  </div>

    <!-- Модалка поиска продукта для замены -->
    <ProductSearchModal
      v-if="showSearchModal"
      :initial-query="searchModalQuery"
      @select="onSearchSelect"
      @close="showSearchModal = false"
    />

    <!-- Модалка поиска для добавления нового продукта -->
    <ProductSearchModal
      v-if="showAddProductModal"
      title="Добавить продукт"
      @select="onAddProductSelect"
      @close="showAddProductModal = false"
    />

    <!-- Попап карточки продукта (полный, как в KnowledgeBase) -->
    <ProductDetails
      v-if="productDetailsData"
      :product="productDetailsData"
      :sex="userSex"
      :age="userAge"
      :z-index="120"
      @close="productDetailsData = null"
    />

    <!-- Скрытый file input для фото в edit-режиме (iOS сам покажет выбор камера/галерея) -->
    <input ref="photoInput" type="file" accept="image/*" class="hidden" @change="onEditPhotoFile" />

    <!-- Диалог добавления продукта в базу (этикетка) -->
    <LabelReviewDialog
      v-if="labelDialogVisible"
      v-model="labelDialogVisible"
      :barcode="labelDialogBarcode"
      :initial-data="labelDialogData"
      @submitted="onLabelSubmitted"
    />

    <!-- Диалог коррекции продукта (найденного по штрихкоду) -->
    <LabelReviewDialog
      v-if="correctionDialogVisible"
      v-model="correctionDialogVisible"
      :initial-data="correctionDialogData"
      :original-product-id="correctionOriginalProductId"
      :start-in-review="true"
      :show-barcode-scanner="false"
      mode="correction"
      header-text="Исправление данных"
      @submitted="onCorrectionSubmitted"
    />

    <!-- Дата/время приёма + повтор (телепортируется в body поверх диалога) -->
    <TimePickerPopup
      v-if="showTimePopup"
      :date="mealDate"
      :start-hour="mealStartH"
      :start-min="mealStartM"
      :end-hour="mealEndH"
      :end-min="mealEndM"
      show-repeat
      :repeat="repeatRule"
      @confirm="onTimeRepeatConfirm"
      @close="showTimePopup = false"
    />
  </Teleport>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, nextTick, watch } from 'vue'
import api from '../services/api.js'
import { CORRECTION_PROMPT_VERSION } from '../utils/promptVersions'
import { startNetProbe } from '../utils/netdiag.js'
import { withAiJob } from '../utils/aiProgress.js'
import { imgUrl } from '../utils/image.js'
import { useAuthStore } from '../store/auth.js'
import { useUnitsStore } from '../store/units.js'
import { unitFor, matchBuiltin, qtyFromGrams, gramsFromQty, fmtQty } from '../utils/units.js'
import UnitSheet from './UnitSheet.vue'
import ProductSearchModal from './ProductSearchModal.vue'
import ProductDetails from './ProductDetails.vue'
import LabelReviewDialog from './LabelReviewDialog.vue'
import TimePickerPopup from './TimePickerPopup.vue'
import DishTagsEditor from './DishTagsEditor.vue'
import { useFavTagsStore } from '../store/favTags.js'
import { planRuleChange, ruleHasAny, deriveRuleView, ruleSummary, effectiveAnchorDate, todayDateStr, todayStartIso } from '../utils/repeatRule.js'
import { cacheClearFutureDiary } from '../services/cache.js'
import { uuid } from '../utils/uuid.js'
import { describeSaveError, isNetworkFailure } from '../utils/saveError.js'
import { offline as netOffline, registerPendingSave, unregisterPendingSave } from '../services/netStatus.js'
import { markUnsaved, clearUnsaved } from '../services/unsaved.js'
import { saveDraft, clearDraft, putPhoto, serializeItems } from '../services/drafts.js'
import { track } from '../analytics.js'
import guide from '../services/guide.js'
import { roundWeight, distributeWeights } from '../utils/weights.js'

const authStore = useAuthStore()

// ── Diary visibility from diary_settings ──
const ds = computed(() => {
  const defaults = { show_kcal: true, show_protein: true, show_fat: true, show_carbs: true }
  return { ...defaults, ...(authStore.user?.diary_settings || {}) }
})
const showKcal    = computed(() => ds.value.show_kcal)
const showProtein = computed(() => ds.value.show_protein)
const showFat     = computed(() => ds.value.show_fat)
const showCarbs   = computed(() => ds.value.show_carbs)
const showFiber   = computed(() => ds.value.show_fiber)
const showWeight = computed(() => ds.value.show_weight ?? true)
const anyKbjuVisible = computed(() => showKcal.value || showProtein.value || showFat.value || showCarbs.value)

const userSex = computed(() => authStore.user?.sex || 'm')
const userAge = computed(() => {
  const bd = authStore.user?.birth_date
  if (!bd) return null
  return Math.floor((Date.now() - new Date(bd).getTime()) / (365.25 * 24 * 60 * 60 * 1000))
})

const props = defineProps({
  loading: { type: Boolean, default: false },
  mode: { type: String, default: 'photo' },        // 'photo' | 'repeat' | 'edit' | 'text'
  items: { type: Array, default: () => [] },
  photoUrl: { type: String, default: null },        // для repeat — URL уже загруженного фото
  previewUrl: { type: String, default: null },      // для photo — blob URL превью
  confidence: { type: Number, default: 0 },
  // Запись журнала распознаваний, из которой открыто окно (AddFoodDialog)
  recognitionId: { type: Number, default: null },
  // Порций на рецепт (zoya_dishes.portions_count): повтор считается порциями
  portionsCount: { type: Number, default: null },
  photoBase64: { type: String, default: null },
  photoMime: { type: String, default: 'image/jpeg' },
  // Голосовой ввод: mode остаётся 'photo' (тот же путь результата), но фото
  // нет, а voiceTranscript — что модель услышала
  voice: { type: Boolean, default: false },
  voiceTranscript: { type: String, default: '' },
  // Иконки продуктов блюда без фото — ключи из data/food-icons.json
  icons: { type: Array, default: () => [] },
  dishNameProp: { type: String, default: null },

  dishId: { type: Number, default: null },
  initialFavorite: { type: Boolean, default: false },
  isEditedCooking: { type: Boolean, default: false },
  cookedWeightG: { type: Number, default: null },
  entryIds: { type: Array, default: () => [] },
  eatenAt: { type: String, default: null },
  enriching: { type: Boolean, default: false },
  hidden: { type: Boolean, default: false },
  // Показанное фото — личная замена картинки продукта, а не картинка из базы.
  // Нужно, чтобы предложить вернуть исходную.
  productPhotoCustom: { type: Boolean, default: false },
  // Текущее правило дублирования блюда (edit-режим): {tomorrow, weekdays,
  // alldays, anchor_date} или null. Передаёт Diary из записей блюда.
  duplicateRule: { type: Object, default: null },
  // Черновик, из которого окно восстановлено после перезагрузки
  // (services/drafts.js): название, время приёма, теги, ключи сохранения.
  // Позиции приходят как обычно через items.
  draft: { type: Object, default: null },
})

// Текущее распознавание: после правки «одним словом» сервер выдаёт новую
// запись с parent_id на прежнюю, и в дневник должна уйти последняя
const currentRecognitionId = ref(props.recognitionId)
watch(() => props.recognitionId, (v) => { currentRecognitionId.value = v })

const emit = defineEmits(['close', 'added', 'deleted', 'refresh', 'favorite-toggled', 'tags-changed'])

// ── Время приёма и дублирование ──────────────────────────────────────────────
// Время выбирается прямо при добавлении (раньше всегда бралось текущее, а
// менять приходилось потом у всего MealGroup). Инициализация — из props.eatenAt
// (добавление в существующий приём, редактирование) или от текущего момента,
// с округлением до 5 минут, как в MealGroup.
const showTimePopup = ref(false)
const mealDate = ref('')
const mealStartH = ref(12)
const mealStartM = ref(0)
const mealEndH = ref(12)
const mealEndM = ref(20)
// Правило повтора: в новых режимах копится локально и применяется при
// сохранении; в edit-режиме применяется сразу из попапа (appliedRule —
// последнее записанное на сервер состояние, чтобы считать дифф).
// Чекбоксы — деривированный вид: горят, только пока у варианта остались
// будущие даты. Само хранимое правило (appliedRule) держим сырым — planRuleChange
// нужен его якорь, чтобы найти и удалить уже созданные копии.
const repeatRule = ref(deriveRuleView(props.duplicateRule))
const appliedRule = ref(props.duplicateRule || null)

{
  const base = props.eatenAt ? new Date(props.eatenAt) : new Date()
  // Округление ВНИЗ: Math.round в 13:58 показывал бы 14:00 — время «из
  // будущего» выглядит взявшимся неизвестно откуда
  base.setMinutes(Math.floor(base.getMinutes() / 5) * 5, 0, 0)
  mealDate.value = `${base.getFullYear()}-${String(base.getMonth() + 1).padStart(2, '0')}-${String(base.getDate()).padStart(2, '0')}`
  mealStartH.value = base.getHours()
  mealStartM.value = base.getMinutes()
  const end = new Date(base.getTime() + 20 * 60000)
  mealEndH.value = end.getHours()
  mealEndM.value = end.getMinutes()
}

function mealDateTimeIso(h, m) {
  const d = new Date(`${mealDate.value}T00:00:00`)
  d.setHours(h, m, 0, 0)
  return d.toISOString()
}

const MONTHS_GEN = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря']

const mealTimeLabel = computed(() => {
  const pad = n => String(n).padStart(2, '0')
  const time = `${pad(mealStartH.value)}:${pad(mealStartM.value)}`
  const fmt = d => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
  const today = new Date()
  const tomorrow = new Date(today.getTime() + 86400000)
  if (mealDate.value === fmt(today)) return `Сегодня, ${time}`
  if (mealDate.value === fmt(tomorrow)) return `Завтра, ${time}`
  const d = new Date(`${mealDate.value}T00:00:00`)
  return `${d.getDate()} ${MONTHS_GEN[d.getMonth()]}, ${time}`
})

function repeatDiffers(a, b) {
  return !!a?.today !== !!b?.today
    || !!a?.tomorrow !== !!b?.tomorrow
    || !!a?.weekdays !== !!b?.weekdays
    || !!a?.alldays !== !!b?.alldays
}

// Явная строка повтора над заголовком блюда: что ещё будет продублировано
// («Повторится: завтра / по будням до N / каждый день до N»), а для блюда,
// которое само является копией, — от какого дня оно повторено.
const repeatIndicator = computed(() => {
  const rule = props.mode === 'edit'
    ? appliedRule.value
    : (ruleHasAny(repeatRule.value)
        ? { ...repeatRule.value, anchor_date: effectiveAnchorDate(mealDate.value) }
        : null)
  const summary = rule ? ruleSummary(rule) : null
  if (summary) return `Повторится: ${summary}`
  const anchor = props.duplicateRule?.anchor_date
  if (anchor && anchor < mealDate.value) {
    const d = new Date(anchor + 'T00:00:00')
    return `Повтор блюда от ${d.getDate()} ${MONTHS_GEN[d.getMonth()]}`
  }
  return null
})

async function onTimeRepeatConfirm({ date, startHour, startMin, endHour, endMin, repeat }) {
  showTimePopup.value = false
  // Сравнение — с деривированным видом: у исчерпанного правила хранимое
  // tomorrow может быть true при погасшем чекбоксе, и сырое сравнение
  // считало бы повторную галочку «ничего не изменилось»
  const ruleChanged = repeatDiffers(repeatRule.value, repeat)
    || repeatDiffers(deriveRuleView(appliedRule.value), repeat)
  mealDate.value = date
  mealStartH.value = startHour
  mealStartM.value = startMin
  mealEndH.value = endHour
  mealEndM.value = endMin
  repeatRule.value = { ...repeat }

  // В edit-режиме записи уже существуют — время и повтор применяются сразу,
  // не дожидаясь «Сохранить»: пользователь мог открыть попап только ради них.
  if (props.mode === 'edit' && props.entryIds.length) {
    try {
      await api.patch('/diary/group-time', {
        entry_ids: props.entryIds,
        eaten_at: mealDateTimeIso(startHour, startMin),
        meal_end_at: mealDateTimeIso(endHour, endMin),
      })
      if (ruleChanged) {
        // Якорь нового правила — дата блюда (для прошлых блюд — сегодня), а не
        // якорь прошлого раунда: «завтра» от старого якоря — уже прошедший
        // день, и именно на этом повторное дублирование молча делало ничего
        const rule = { ...repeat, anchor_date: effectiveAnchorDate(date) }
        const { add_offsets, remove_ranges } = planRuleChange(appliedRule.value, rule, date)
        await api.post('/diary/duplicate', {
          entry_ids: props.entryIds,
          rule,
          add_offsets,
          remove_ranges,
          // Граница сегодняшних суток клиента — ради копии «на сегодня»
          not_before: todayStartIso(),
        })
        appliedRule.value = rule
        cacheClearFutureDiary(todayDateStr())
      }
      emit('refresh')
    } catch (err) {
      console.error('Time/repeat update error:', err.response?.data?.error || err.message)
    }
  }
}

// Локальная копия items для редактирования
const localItems = ref([])
const confidenceVal = ref(props.confidence)
const addingAll = ref(false)
// Текст под кнопкой, если сохранение не прошло. Не alert: тот блокирует
// экран, а на сетевом обрыве ещё и врёт — см. utils/saveError.js.
const saveError = ref('')
// Сохранение идёт дольше 5 с — в кнопке «связь медленная» (без шторки)
const slowSave = ref(false)
let slowSaveTimer = null
// Ключ этого окна в реестре неотправленных сохранений (netStatus):
// при обрыве окно остаётся открытым и повторяет отправку само, когда связь
// вернётся. Повтор безопасен — client_id пакета и записей те же.
const pendingSaveKey = Symbol('PhotoRecognizeDialog')
// Пока окно открыто, автообновление приложения не перезагружает страницу
const unsavedKey = Symbol('PhotoRecognizeDialog')
// Черновик приёма: всё, кроме правки существующих записей — у той оригинал
// и так в дневнике, терять нечего. Пишется с задержкой по любому изменению,
// снимается при размонтировании: перезагрузка и выгрузка iOS окно не
// размонтируют, а закрытие и сохранение — да.
const draftable = props.mode !== 'edit'
let draftTimer = null
function persistDraft() {
  if (!draftable || props.loading || localItems.value.length === 0) return
  saveDraft('meal', {
    mode: props.mode,
    voice: props.voice,
    voiceTranscript: props.voiceTranscript,
    recognitionId: currentRecognitionId.value,
    confidence: props.confidence,
    portionsCount: props.portionsCount,
    photoUrl: props.photoUrl,
    photoMime: props.photoMime,
    hasPhoto: !!props.photoBase64,
    dishId: props.dishId,
    isEditedCooking: props.isEditedCooking,
    cookedWeightG: props.cookedWeightG,
    dishName: dishName.value,
    mealDate: mealDate.value,
    mealStartH: mealStartH.value, mealStartM: mealStartM.value,
    mealEndH: mealEndH.value, mealEndM: mealEndM.value,
    tags: dishTags.value,
    saveClientId,
    items: serializeItems(localItems.value),
  })
}
function scheduleDraft() {
  if (!draftable) return
  if (draftTimer) clearTimeout(draftTimer)
  draftTimer = setTimeout(persistDraft, 400)
}
// Ключ идемпотентности пакета. Новый — только после удачного сохранения:
// повтор после обрыва должен уйти с тем же ключом.
let saveClientId = uuid()
const refining = ref(false)
const correction = ref('')
const editingIdx = ref(-1)
const weightInputRef = ref(null)
const isFavorite = ref(props.initialFavorite)

// Теги Избранного. У существующего блюда читаются с сервера и сохраняются
// сразу, как сердечко; у нового — живут здесь до сохранения блюда.
const dishTags = ref([])
// Объявлены до watch: он срабатывает сразу (immediate) и обращается к ним.
// Стояли ниже — первый же запуск падал, и теги блюда не загружались.
const savedTags = ref([])   // то, что сохранено на сервере
const tagDishId = ref(null) // блюдо, заведённое записи без блюда при первом теге
watch(() => props.dishId, async (id) => {
  dishTags.value = []
  savedTags.value = []
  tagDishId.value = null
  if (!id) return
  try {
    const { data } = await api.get(`/diary/dishes/${id}/tags`)
    if (props.dishId === id) { dishTags.value = data.tags || []; savedTags.value = dishTags.value }
  } catch { /* без тегов блюдо открывается как раньше */ }
}, { immediate: true })

// Продукт из поиска, добавленный до появления блюд-из-одной-позиции, лежит в
// дневнике записью без блюда. Блюдо ему заводит сервер при первом теге — как
// при первом сердечке (PUT /diary/entries/:id/tags).
// При правке блюда теги — часть правки: меняются на экране и сохраняются
// кнопкой «Сохранить изменения», как название и граммы. Сохранение сразу
// оставляло кнопку неактивной, и было непонятно, применились ли теги.
const tagsDirty = computed(() => [...dishTags.value].sort().join('|') !== [...savedTags.value].sort().join('|'))

async function saveTagsNow(list) {
  const dishId = props.dishId || tagDishId.value
  if (dishId) {
    dishTags.value = await useFavTagsStore().setDishTags(dishId, list)
    emit('tags-changed', { dishId, tags: dishTags.value })
  } else if (props.entryIds.length) {
    const { data } = await api.put(`/diary/entries/${props.entryIds[0]}/tags`, { tags: list })
    tagDishId.value = data.dish_id
    dishTags.value = data.tags || []
    emit('tags-changed', { dishId: data.dish_id, tags: dishTags.value })
  }
  savedTags.value = dishTags.value
}

async function onDishTagsInput(list) {
  const prev = dishTags.value
  dishTags.value = list
  if (props.mode === 'edit') return
  const dishId = props.dishId || tagDishId.value
  try {
    if (dishId) {
      dishTags.value = await useFavTagsStore().setDishTags(dishId, list)
      emit('tags-changed', { dishId, tags: dishTags.value })
    } else if (props.mode === 'edit' && props.entryIds.length) {
      const { data } = await api.put(`/diary/entries/${props.entryIds[0]}/tags`, { tags: list })
      tagDishId.value = data.dish_id
      dishTags.value = data.tags || []
      emit('tags-changed', { dishId: data.dish_id, tags: dishTags.value })
    }
    // Новое блюдо — теги запишутся после сохранения
  } catch { dishTags.value = prev }
}
const originalItems = ref([])
const originalDishName = ref('')
const deletingDish = ref(false)
const portionWeight = ref(300)
const portionWeightStr = ref('300')
let _portionWeightFromInput = false
function onPortionWeightInput(e) {
  const raw = e.target.value.replace(',', '.')
  portionWeightStr.value = e.target.value
  const num = parseFloat(raw)
  _portionWeightFromInput = true
  portionWeight.value = isNaN(num) ? 0 : num
}
watch(portionWeight, (v) => {
  if (_portionWeightFromInput) { _portionWeightFromInput = false; return }
  portionWeightStr.value = String(v)
})
function parseDecimal(str) {
  const num = parseFloat(String(str).replace(',', '.'))
  return isNaN(num) ? 0 : num
}

// ── Штуки и порции (utils/units.js, store/units.js) ──
// У позиции может быть единица: личная порция продукта, встроенный размер
// (яйцо, банан) или та, что была введена при сохранении записи. Граммы —
// правда, qty — как это выглядит для человека; правится любое из двух.
const unitsStore = useUnitsStore()
const editField = ref('g')          // что сейчас в поле: 'qty' | 'g'
const unitSheetIdx = ref(-1)

function applyUnit(item) {
  if (!item) return
  if (!item._unit && item.unit_name && item.unit_g > 0) {
    // Из сохранённой записи: единица на момент записи, не пересчитываем
    item._unit = { name: item.unit_name, grams: Number(item.unit_g), kind: 'entry' }
    if (!(item.qty > 0)) item.qty = qtyFromGrams(item.weight_g, item._unit.grams)
    return
  }
  if (item._unit && item._unit.kind !== 'entry' && item._unit.kind !== 'builtin') return
  const u = unitFor(item, unitsStore.personal)
  if (!u) return
  // Встроенная единица могла быть применена до загрузки настроек с размером
  // по умолчанию — обновляем на выбранный размер, штуки пересчитываем от граммов
  if (item._unit && item._unit.kind === 'builtin') {
    if (u.grams !== item._unit.grams || u.kind !== 'builtin') { item._unit = u; item.qty = qtyFromGrams(item.weight_g, u.grams) }
    return
  }
  item._unit = u
  if (item.qty > 0 && item.unit_hint) {
    // «2 яйца» из чата: количество известно, граммы считаем по штуке
    item.weight_g = gramsFromQty(item.qty, u.grams) || item.weight_g
    item.unit_hint = null
    recalc(item)
  } else {
    item.qty = qtyFromGrams(item.weight_g, u.grams)
  }
}
function applyUnitsAll() { for (const item of localItems.value) applyUnit(item) }
// Карточки продуктов приходят после подбора КБЖУ — единица могла появиться.
// До загрузки личных единиц ничего не применяем: иначе размер по умолчанию
// закрепился бы раньше выбранного.
watch(() => localItems.value.map(i => i.product_id || '').join(','), () => { if (unitsStore.loaded) applyUnitsAll() })

function onWeightFieldInput(item, raw) {
  const n = parseDecimal(raw)
  if (editField.value === 'qty' && item._unit) {
    item.qty = n
    item.weight_g = gramsFromQty(n, item._unit.grams) || 0
  } else {
    item.weight_g = n
    if (item._unit) item.qty = qtyFromGrams(n, item._unit.grams)
  }
}
function openUnitSheet(i) { unitSheetIdx.value = i }
function onUnitSelected(u) {
  const item = localItems.value[unitSheetIdx.value]
  if (!item) return
  if (u) {
    item._unit = u
    item.qty = qtyFromGrams(item.weight_g, u.grams)
  } else {
    item._unit = null
    item.qty = null
  }
  // Единица могла стать личной для всех позиций этого продукта
  applyUnitsAll()
}

// Повтор рецепта порциями: вес порции = вес блюда / порций на рецепт
const portionG = computed(() => (props.portionsCount > 0 && props.cookedWeightG > 0)
  ? props.cookedWeightG / props.portionsCount : null)
const portionsQty = ref(1)
function stepPortions(d) {
  const n = Math.max(0.5, Math.round(((portionsQty.value || 0) + d) * 2) / 2)
  portionsQty.value = n
  if (portionG.value) portionWeight.value = Math.round(n * portionG.value)
}
watch(portionWeight, (v) => {
  if (portionG.value) portionsQty.value = Math.round(v / portionG.value * 10) / 10
})
const editingPortionWeight = ref(false)
const portionWeightInputRef = ref(null)
const recipeIngredients = ref({})
const editingIngIdx = ref('')
const ingWeightInputRef = ref(null)
const localEnriching = ref(false)
const isEnriching = computed(() => props.enriching || localEnriching.value)

// ── Label Review Dialog (добавление продукта в БД) ──
const labelDialogVisible = ref(false)
const labelDialogIdx = ref(-1)

const labelDialogData = computed(() => {
  const item = localItems.value[labelDialogIdx.value]
  if (!item) return null
  if (item._hasLabelData && item.label_kbju) {
    return { name: item.name, brand: item.brand, per100: item.label_kbju }
  }
  return null
})

const labelDialogBarcode = computed(() => {
  const item = localItems.value[labelDialogIdx.value]
  return item?.barcode || null
})

function openLabelReview(index) {
  labelDialogIdx.value = index
  labelDialogVisible.value = true
}

function onLabelSubmitted(result) {
  const item = localItems.value[labelDialogIdx.value]
  if (!item) return
  const p = result.product
  item.product_id = p.id
  item.db_name = p.name
  item.matched = true
  item._submitted = true
  item._usedFallback = false
  item._hasLabelData = false
  // Пересчёт КБЖУ на вес порции
  const per100 = {
    kcal: p.kcal ?? null,
    protein: p.protein ?? null,
    fat: p.fat ?? null,
    carbs: p.carbs ?? null,
  }
  const w = item.weight_g || 100
  const calc = v => v != null ? Math.round(v * w / 100 * 10) / 10 : null
  item.kcal = calc(per100.kcal)
  item.protein = calc(per100.protein)
  item.fat = calc(per100.fat)
  item.carbs = calc(per100.carbs)
  item.per100 = per100
  localItems.value.splice(labelDialogIdx.value, 1, { ...item })
}

// ── Коррекция продукта (найденного по штрихкоду) ──
const correctionDialogVisible = ref(false)
const correctionItemIdx = ref(-1)

const correctionOriginalProductId = computed(() => {
  const item = localItems.value[correctionItemIdx.value]
  return item?.product_id || null
})

// Красным — только позиция без цифр: в базе не нашлась, и ни оценки модели, ни
// этикетки нет (или подбор не дошёл до сервера). Цифры модели и этикетки — не
// ошибка: у них своя метка «ИИ» и кнопка «Сфотографировать этикетку». До
// 18.10.2026 красными были все позиции без карточки, в том числе с верными
// цифрами с упаковки, и при повторном открытии блюда — тоже.
function isUnresolved(item) {
  if (!item || item.type === 'recipe' || item.matched !== false) return false
  if (item._enrichFailed) return true
  if (item._usedFallback || item._hasLabelData) return false
  return item.kcal == null
}

const correctionDialogData = computed(() => {
  const item = localItems.value[correctionItemIdx.value]
  if (!item) return null
  return {
    name: item.db_name || item.name,
    brand: item.brand || null,
    per100: item.per100 || null,
    ingredients_text: item.ingredients_text || null,
  }
})

function openCorrectionDialog(index) {
  correctionItemIdx.value = index
  correctionDialogVisible.value = true
}

async function onCorrectionSubmitted(result) {
  const item = localItems.value[correctionItemIdx.value]
  if (!item) return
  const p = result.product
  // Обновляем данные продукта на исправленные
  item.product_id = p.id
  item.db_name = p.name
  item.name = p.name
  item.matched = true
  item._usedFallback = false
  item._hasLabelData = false
  item.per100 = { kcal: p.kcal ?? null, protein: p.protein ?? null, fat: p.fat ?? null, carbs: p.carbs ?? null }
  const w = item.weight_g || 100
  const calc = v => v != null ? Math.round(v * w / 100 * 10) / 10 : null
  item.kcal = calc(p.kcal)
  item.protein = calc(p.protein)
  item.fat = calc(p.fat)
  item.carbs = calc(p.carbs)
  localItems.value.splice(correctionItemIdx.value, 1, { ...item })
}

// ── Фото в edit-режиме ──
const editPhotoBase64 = ref(null)
const editPhotoMime = ref(null)
const editPhotoPreview = ref(null)
const photoInput = ref(null)

// ── Советы по распознаванию (карусель) ──
const RECOGNITION_TIPS = [
  { title: 'Масштаб важен для точного веса.', body: 'Положите рядом с едой вилку, ложку или обычную монетку. Любой стандартный предмет поможет ИИ понять реальный размер порции.' },
  { title: 'Снимайте крупным планом.', body: 'Предпочтительнее фотографировать каждое блюдо отдельно. Так распознавание работает точнее.' },
  { title: 'Больше света, меньше теней.', body: 'Фотографируйте при хорошем освещении. Следите, чтобы на блюдо не падала тень от телефона или рук.' },
  { title: 'Держите фокус.', body: 'Избегайте размытых фотографий. Тапните по экрану телефона перед съемкой, чтобы камера сфокусировалась на еде.' },
  { title: 'Перемешайте сложные блюда.', body: 'Если это сложный салат или суп, слегка зачерпните ингредиенты, чтобы нейросеть разглядела, что спрятано под бульоном или соусом.' },
]
// Для голосового ввода — свои советы: про свет и фокус тут говорить не о чем
const VOICE_TIPS = [
  { title: 'Называйте вес или количество.', body: '«Двести грамм», «два куска», «стакан» — так вес в дневнике будет точным. Без этого ИИ поставит обычную порцию.' },
  { title: 'Уточняйте состав.', body: '«Каша на воде», «кофе без сахара», «салат с маслом» — детали заметно меняют калорийность.' },
  { title: 'Один приём пищи — одна запись.', body: 'Перечислите всё, что было на столе, а завтрак и обед наговорите отдельно.' },
  { title: 'Ошиблись — просто поправьтесь.', body: 'Скажите «нет, не двести, а триста» — ИИ возьмёт последнее. Состав можно исправить и после распознавания.' },
]
const tips = computed(() => props.voice ? VOICE_TIPS : RECOGNITION_TIPS)
const currentTipIndex = ref(Math.floor(Math.random() * RECOGNITION_TIPS.length))
let tipTimer = null

function startTipTimer() {
  stopTipTimer()
  tipTimer = setInterval(() => {
    currentTipIndex.value = (currentTipIndex.value + 1) % RECOGNITION_TIPS.length
  }, 8000)
}
function stopTipTimer() {
  if (tipTimer) { clearInterval(tipTimer); tipTimer = null }
}

// ── Фото в edit-режиме: функции ──
function openPhotoMenu() {
  photoInput.value?.click()
}

function resizeAndEncode(file, maxPx) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    const url = URL.createObjectURL(file)
    img.onload = () => {
      URL.revokeObjectURL(url)
      const scale = Math.min(1, maxPx / Math.max(img.width, img.height))
      const w = Math.round(img.width * scale)
      const h = Math.round(img.height * scale)
      const canvas = document.createElement('canvas')
      canvas.width = w; canvas.height = h
      canvas.getContext('2d').drawImage(img, 0, 0, w, h)
      const dataUrl = canvas.toDataURL('image/jpeg', 0.85)
      resolve(dataUrl.split(',')[1])
    }
    img.onerror = reject
    img.src = url
  })
}

// Пользователь попросил вернуть картинку из базы. Применяем при сохранении —
// вместе с остальными правками блюда, чтобы «Отмена» отменяла и это тоже.
const resetProductPhoto = ref(false)

async function onEditPhotoFile(e) {
  const file = e.target.files?.[0]
  if (!file) return
  e.target.value = ''

  resetProductPhoto.value = false
  editPhotoPreview.value = URL.createObjectURL(file)
  editPhotoMime.value = file.type || 'image/jpeg'
  // 1536 px как в AddFoodDialog: у Gemini 3.x входные токены за фото от размера не зависят
  editPhotoBase64.value = await resizeAndEncode(file, 1536)
}

// ── Карта ключей JSONB Скурихина → короткое название (витамины/минералы) ──
const NUTRIENT_KEYS = {
  A:   'Витамин А, РЭ',       C:   'Витамин C, аскорбиновая',
  D:   'Витамин D, кальциферол', E: 'Витамин Е, альфа токоферол, ТЭ',
  K:   'Витамин К, филлохинон', B1:  'Витамин В1, тиамин',
  B2:  'Витамин В2, рибофлавин', B3: 'Витамин РР, НЭ',
  B5:  'Витамин В5, пантотеновая', B6: 'Витамин В6, пиридоксин',
  B7:  'Витамин Н, биотин',    B9:  'Витамин В9, фолаты',
  B12: 'Витамин В12, кобаламин', Ca: 'Кальций, Ca',
  Fe:  'Железо, Fe',           Mg:  'Магний, Mg',
  Zn:  'Цинк, Zn',            I:   'Йод, I',
  Se:  'Селен, Se',            Cu:  'Медь, Cu',
  Mn:  'Марганец, Mn',         Cr:  'Хром, Cr',
  Mo:  'Молибден, Mo',         K_m: 'Калий, K',
  Na:  'Натрий, Na',           Cl:  'Хлор, Cl',
  P:   'Фосфор, P',
}

function extractVitaminsFromNutrients(nutrients, weightG) {
  if (!nutrients) return {}
  const ratio = weightG / 100
  const result = {}
  for (const [key, jsonKey] of Object.entries(NUTRIENT_KEYS)) {
    const item = nutrients[jsonKey]
    if (item?.val != null) {
      result[key] = Math.round(item.val * ratio * 100) / 100
    }
  }
  return result
}

// ── Поиск продукта для замены ────────────────────────
const showSearchModal = ref(false)
const searchModalQuery = ref('')
const searchTarget = ref(null) // { type: 'item', itemIdx } | { type: 'ingredient', itemIdx, ingIdx }

function openSearchForItem(itemIdx) {
  const item = localItems.value[itemIdx]
  searchTarget.value = { type: 'item', itemIdx }
  searchModalQuery.value = item.name
  showSearchModal.value = true
}

function openSearchForIngredient(itemIdx, ingIdx) {
  const ing = localItems.value[itemIdx]?.ingredients?.[ingIdx]
  if (!ing) return
  searchTarget.value = { type: 'ingredient', itemIdx, ingIdx }
  searchModalQuery.value = ing.name
  showSearchModal.value = true
}

function onSearchSelect(product) {
  showSearchModal.value = false
  expandedIngIdx.value = -1
  expandedSubIngIdx.value = ''
  const target = searchTarget.value
  if (!target) return

  const per100 = {
    kcal: product.kcal != null ? parseFloat(product.kcal) : null,
    protein: product.protein != null ? parseFloat(product.protein) : null,
    fat: product.fat != null ? parseFloat(product.fat) : null,
    carbs: product.carbs != null ? parseFloat(product.carbs) : null,
    fiber: product.fiber != null ? parseFloat(product.fiber) : null,
    water: product.water != null ? parseFloat(product.water) : null,
  }

  if (target.type === 'item') {
    // Замена продукта (direct, package или recipe → direct)
    const item = localItems.value[target.itemIdx]
    if (!item) return
    const prev = { name: item.name, product_id: item.product_id ?? null }
    item.name = product.name
    item.product_id = product.id
    item.db_name = product.name
    item.per100 = per100
    item.matched = true
    item._usedFallback = false
    item._source = product.source || null
    item._dbSource = product.source || null
    // Карточка выбрана руками: раскладка крупы и ужарка относились к прежней
    // записи, с новой per100 считается напрямую от веса.
    item._grain = null
    item._grainParts = null
    item._cooking = null
    // При замене recipe → direct: убираем суб-ингредиенты
    if (item.type === 'recipe') {
      item.type = 'direct'
      item.ingredients = undefined
      item._ingredientsEdited = false
    }
    // Пересчитываем КБЖУ
    const w = item.weight_g || 100
    const calc = (v) => v != null ? Math.round(v * w / 100 * 10) / 10 : null
    item.kcal = calc(per100.kcal)
    item.protein = calc(per100.protein)
    item.fat = calc(per100.fat)
    item.carbs = calc(per100.carbs)
    item.fiber = calc(per100.fiber)
    item.water = calc(per100.water)
    // Пересчитываем витамины из nutrients JSONB
    const vit = extractVitaminsFromNutrients(product.nutrients, w)
    item._totalVitamins = Object.keys(vit).length > 0 ? vit : null
    localItems.value.splice(target.itemIdx, 1, { ...item })
    sendMappingFeedback(prev, product)
  } else if (target.type === 'ingredient') {
    // Замена ингредиента
    const item = localItems.value[target.itemIdx]
    const ing = item?.ingredients?.[target.ingIdx]
    if (!ing) return
    const prev = { name: ing.name, product_id: ing.product_id ?? null }
    ing.name = product.name
    ing.product_id = product.id
    ing.db_name = product.name
    ing.per100 = per100
    ing.matched = true
    ing.nutrients = product.nutrients || null
    ing._source = product.source || null
    ing._dbSource = product.source || null
    // Продукт выбран руками — прежняя раскладка крупы к нему не относится,
    // иначе строка продолжит обещать граммы сухих от совсем другой записи
    ing._grain = null
    ing._cooking = null
    // Пересчитываем витамины ингредиента
    const ingVit = extractVitaminsFromNutrients(product.nutrients, ing.weight_g || 0)
    ing.vitamins = ingVit
    item._ingredientsEdited = true
    recalcFromIngredients(item)
    localItems.value.splice(target.itemIdx, 1, { ...item })
    sendMappingFeedback(prev, product)
  }
}

// Человек заменил подобранную карточку — сигнал для подбора
// (lib/mappingFeedback.js, админка → «Замены»). Молча и в фоне: окну это не
// нужно. Имя берётся до замены — после неё item.name уже имя карточки.
function sendMappingFeedback(prev, product) {
  if (!prev?.name || !product?.id || prev.product_id === product.id) return
  api.post('/ai/mapping-feedback', {
    search_name: prev.name,
    matched_product_id: prev.product_id,
    chosen_product_id: product.id,
    recognition_id: currentRecognitionId.value || null,
    source: props.voice ? 'voice' : props.mode,
  }).catch(() => {})
}

// Проверка: есть ли хотя бы один item с ингредиентами (для заголовка "Состав:")
const hasAnyIngredients = computed(() => {
  return localItems.value.some(item => item.type !== 'direct' && item.ingredients?.length > 0)
})

// ── Мини-карточка ингредиента (раскрытие по клику) ──
const expandedIngIdx = ref(-1)
const expandedSubIngIdx = ref('')

function toggleIngredientCard(idx) {
  expandedIngIdx.value = expandedIngIdx.value === idx ? -1 : idx
  expandedSubIngIdx.value = ''
}

// Состав на 100 г — промежуточное число, а не то, что показывают: экран всюду
// умножает его на вес и округляет сам. Одного знака здесь не хватало — снимок
// блюда с per100.fiber 1,2 вместо 1,158 давал на порции 380 г 4,6 против 4,4 в
// карточке дневника. Держим с запасом, ошибка уходит на четвёртый знак.
function per100Of(value, weightG) {
  const w = parseFloat(weightG)
  if (value == null || !Number.isFinite(w) || w <= 0) return null
  return Math.round(Number(value) / w * 100 * 1e4) / 1e4
}

function fmtG(v) {
  const n = parseFloat(v) || 0
  return n >= 10 ? Math.round(n) : Math.round(n * 10) / 10
}

function toggleSubIngredientCard(itemIdx, ingIdx) {
  const key = `${itemIdx}-${ingIdx}`
  expandedSubIngIdx.value = expandedSubIngIdx.value === key ? '' : key
}

// ── Карточка продукта (попап ProductDetails) ──
const productDetailsData = ref(null)

async function openProductDetails(itemIdx) {
  const item = localItems.value[itemIdx]
  if (!item?.product_id) return
  try {
    const { data } = await api.get(`/products/${item.product_id}`)
    productDetailsData.value = data
  } catch (err) {
    console.error('Product details error:', err)
  }
}

async function openSubIngProductDetails(itemIdx, ingIdx) {
  const ing = localItems.value[itemIdx]?.ingredients?.[ingIdx]
  if (!ing?.product_id) return
  try {
    const { data } = await api.get(`/products/${ing.product_id}`)
    productDetailsData.value = data
  } catch (err) {
    console.error('Product details error:', err)
  }
}

// ── Бейдж источника для item (USDA/Скурихин) ──
function _resolveSourceBadge(source) {
  if (!source) return null
  const s = source.toLowerCase()
  if (s.includes('usda')) return { label: 'USDA', color: '#2D6A4F', bg: '#D4EDDA' }
  if (s.includes('скурихин') || s.includes('skurikhin')) return { label: 'Скурихин', color: '#2D6A4F', bg: '#D4EDDA' }
  return null
}

function getItemSourceBadge(item) {
  return _resolveSourceBadge(item._source) || _resolveSourceBadge(item._dbSource) || null
}

function getIngSourceBadge(ing) {
  return _resolveSourceBadge(ing._source) || _resolveSourceBadge(ing._dbSource) || null
}

// ── Добавить продукт (кнопка "+ Добавить продукт") ──
const showAddProductModal = ref(false)

function openAddProduct() {
  showAddProductModal.value = true
}

async function onAddProductSelect(product) {
  showAddProductModal.value = false
  const totalBefore = compositionTotal()
  const per100 = {
    kcal: product.kcal != null ? parseFloat(product.kcal) : null,
    protein: product.protein != null ? parseFloat(product.protein) : null,
    fat: product.fat != null ? parseFloat(product.fat) : null,
    carbs: product.carbs != null ? parseFloat(product.carbs) : null,
    fiber: product.fiber != null ? parseFloat(product.fiber) : null,
    water: product.water != null ? parseFloat(product.water) : null,
  }
  const w = 100
  const calc = (v) => v != null ? Math.round(v * w / 100 * 10) / 10 : null
  const newItem = {
    name: product.name,
    type: 'direct',
    weight_g: w,
    product_id: product.id,
    db_name: product.name,
    per100,
    kcal: calc(per100.kcal),
    protein: calc(per100.protein),
    fat: calc(per100.fat),
    carbs: calc(per100.carbs),
    fiber: calc(per100.fiber),
    water: calc(per100.water),
    matched: true,
    _usedFallback: false,
    _baseWeight: w,
    _source: product.source || null,
    _dbSource: product.source || null,
  }
  // Витамины
  const vit = extractVitaminsFromNutrients(product.nutrients, w)
  newItem._totalVitamins = Object.keys(vit).length > 0 ? vit : null
  newItem._baseVitamins = newItem._totalVitamins ? { ...newItem._totalVitamins } : null
  localItems.value.push(newItem)
  if (isPortionMode.value) shiftPortionByComposition(totalBefore)
}

// ── Форматирование КБЖУ для мини-карточки ──
function fmtMacro(val) {
  if (val == null) return '0'
  const n = typeof val === 'number' ? val : parseFloat(val)
  if (isNaN(n)) return '0'
  return n < 10 ? (Math.round(n * 10) / 10).toString() : Math.round(n).toString()
}

// ── Scroll-expand (попап растягивается на весь экран) ──
const dialogContentRef = ref(null)
const dialogExpanded = ref(false)

function onDialogScroll() {
  if (!dialogContentRef.value || dialogExpanded.value) return
  if (dialogContentRef.value.scrollTop > 10) {
    dialogExpanded.value = true
  }
}

let savedScrollY = 0
onMounted(async () => {
  savedScrollY = window.scrollY
  document.body.style.position = 'fixed'
  document.body.style.top = `-${savedScrollY}px`
  document.body.style.left = '0'
  document.body.style.right = '0'
  document.body.style.overflow = 'hidden'
  markUnsaved(unsavedKey)
  // Фото — в IndexedDB один раз; черновик без него сохранится без снимка
  if (draftable && props.photoBase64) putPhoto('meal', props.photoBase64, props.photoMime).catch(() => {})

  // Запуск ротации советов если в состоянии загрузки
  if (props.loading && localItems.value.length === 0) startTipTimer()

  // Единицы (штуки, порции): личные из store, встроенные по названию
  unitsStore.load().then(() => {
    applyUnitsAll()
    // Рецепт с порциями: повтор начинается с одной порции, а не с целого блюда
    if (portionG.value && props.mode === 'repeat') nextTick(() => { portionsQty.value = 1; portionWeight.value = Math.round(portionG.value) })
  })

  // Инициализация localItems с _baseWeight и per100
  if (props.items && props.items.length > 0) {
    const totalW = props.items.reduce((s, i) => s + (i.weight_g || 0), 0) || 1
    localItems.value = props.items.map(item => {
      let per100 = item.per100
      if ((!per100 || per100.kcal == null) && item.weight_g > 0 && item.kcal > 0) {
        per100 = {
          kcal:    per100Of(item.kcal, item.weight_g),
          protein: per100Of(item.protein, item.weight_g),
          fat:     per100Of(item.fat, item.weight_g),
          carbs:   per100Of(item.carbs, item.weight_g),
          fiber:   per100Of(item.fiber, item.weight_g),
          water:   per100Of(item.water, item.weight_g),
        }
      }
      const mapped = {
        ...item,
        per100: per100 || {},
        _baseWeight: item.weight_g || 0,
        _baseVitamins: item.vitamins ? { ...item.vitamins } : null,
        _totalVitamins: item.vitamins ? { ...item.vitamins } : (item._totalVitamins || null),
        _dbSource: item._dbSource || item.source || null,
      }
      // Проставить _dbSource для суб-ингредиентов
      if (mapped.ingredients?.length) {
        mapped.ingredients = mapped.ingredients.map(ing => ({
          ...ing,
          _dbSource: ing._dbSource || ing.source || null,
        }))
      }
      return mapped
    })
    // Инициализируем portionWeight:
    // Для рецептов — cooked_weight_g (вес готового блюда), иначе сумма ингредиентов
    if (props.isEditedCooking || props.cookedWeightG > 0 || (props.mode === 'edit' && props.items.length > 1)) {
      _rescaling = true
      _portionRef = portionRefFor(props.cookedWeightG, totalW)
      portionWeight.value = _portionRef
      nextTick(() => { _rescaling = false })
    }
  } else {
    localItems.value = props.items ? props.items.map(item => ({
      ...item,
      _dbSource: item._dbSource || item.source || null,
      ingredients: item.ingredients?.map(ing => ({ ...ing, _dbSource: ing._dbSource || ing.source || null })),
    })) : []
  }
  // Normalize item.vitamins → _totalVitamins (cooking API sets .vitamins,
  // but addAll/scalePortion use _totalVitamins)
  for (const item of localItems.value) {
    if (item.vitamins && !item._totalVitamins) {
      item._totalVitamins = item.vitamins
    }
  }

  if (props.mode === 'edit' || props.mode === 'repeat') {
    originalItems.value = props.items.map(item => ({ ...item }))
    // Загрузить ингредиенты рецептов
    try {
      const names = localItems.value.map(i => i.name.trim().toLowerCase())
      const { data } = await api.get('/diary/recipe', { params: { names: names.join(',') } })
      if (data.recipes) {
        // Преобразуем: { "борщ": { ingredients: [...] } } → { "борщ": [...] }
        const map = {}
        for (const [key, val] of Object.entries(data.recipes)) {
          if (val.ingredients && val.ingredients.length > 0) {
            map[key] = val.ingredients
          }
        }
        recipeIngredients.value = map
        // Обновить type items: если найден рецепт в кэше → type='recipe'
        // Но НЕ менять тип если item уже сохранён как direct (есть product_id) —
        // иначе в edit-режиме продукт станет некликабельным "мёртвым" рецептом
        for (const item of localItems.value) {
          const key = item.name.trim().toLowerCase()
          if (map[key] && !item.product_id) item.type = 'recipe'
        }
      }
    } catch (err) {
      console.error('Recipe fetch error:', err)
    }
  }

  // mode='repeat': перезапрашиваем маппинг для items с product_id=null
  // (override мог быть добавлен после создания оригинальной записи)
  // Пропускаем рецептные items (с sub-ingredients) — они не являются продуктами
  if (props.mode === 'repeat') {
    const unmapped = localItems.value.filter(item => !item.product_id && item.name && !item.ingredients?.length)
    if (unmapped.length > 0) {
      await Promise.all(unmapped.map(async (item) => {
        try {
          const { data } = await api.post('/ai/direct-lookup', {
            name: item.name,
            weight_g: item.weight_g,
            cooking_method: item.cooking_method || 'raw',
            fallback_kbju: null,
          }, { idempotent: true })
          if (data.matched && data.product_id) {
            item.product_id = data.product_id
            item.db_name = data.db_name
            item._grainParts = data.components || null
            item._grain = data.grain || null
            item._cooking = data.cooking || null
            item.kcal = data.kcal
            item.protein = data.protein
            item.fat = data.fat
            item.carbs = data.carbs
            item.per100 = data.per100
            // Не перетираем витамины если уже есть непустые данные (из entry/cooking API)
            const hasExistingVitamins = item._totalVitamins && Object.keys(item._totalVitamins).some(k => k !== '_no_vitamins')
            if (!hasExistingVitamins) {
              item._totalVitamins = data.vitamins && Object.keys(data.vitamins).length > 0 ? data.vitamins : null
              if (data._no_vitamins?.length) item._noVitamins = data._no_vitamins
            }
            if (data.source) item._dbSource = data.source
          }
        } catch (err) {
          // Не критично — используем существующие данные
        }
      }))
      localItems.value = [...localItems.value]
    }
    // Для рецептных items (с sub-ingredients): пересчитываем витамины из sub-ingredients
    // чтобы гарантировать корректный _totalVitamins даже если cooking API не вернул витамины
    for (const item of localItems.value) {
      if (item.ingredients?.length > 0) {
        const prevVitamins = item._totalVitamins
        recalcFromIngredients(item)
        // Если recalc не дал витаминов но ранее были — восстанавливаем
        if (!item._totalVitamins && prevVitamins && Object.keys(prevVitamins).some(k => k !== '_no_vitamins')) {
          item._totalVitamins = prevVitamins
        }
      }
    }
  }

  // mode='text': обогащаем КБЖУ из БД (items приходят без нутриентов)
  if (props.mode === 'text') {
    localEnriching.value = true
    await Promise.all(localItems.value.map(async (item) => {
      try {
        const { data } = await api.post('/ai/direct-lookup', {
          name: item.name,
          weight_g: item.weight_g,
          cooking_method: item.cooking_method || 'raw',
          fallback_kbju: null,
        }, { idempotent: true })
        item.product_id = data.product_id
        item.db_name = data.db_name
        item._grainParts = data.components || null
        item._grain = data.grain || null
        item._cooking = data.cooking || null
        item.kcal = data.kcal
        item.protein = data.protein
        item.fat = data.fat
        item.carbs = data.carbs
        item.fiber = data.fiber
        item.water = data.water
        item.per100 = data.per100
        item._totalVitamins = data.vitamins && Object.keys(data.vitamins).length > 0 ? data.vitamins : null
        if (data._no_vitamins?.length) item._noVitamins = data._no_vitamins
        item._usedFallback = data._usedFallback || false
        item.matched = data.matched
        if (data.source) item._dbSource = data.source
      } catch (err) {
        console.error('Text enrich error for', item.name, err)
      }
    }))
    // Установить _baseVitamins для корректного rescaleToPortionWeight
    for (const item of localItems.value) {
      if (item._totalVitamins && !item._baseVitamins) {
        item._baseVitamins = { ...item._totalVitamins }
        item._baseWeight = item._baseWeight || item.weight_g || 0
      }
    }
    localItems.value = [...localItems.value]
    localEnriching.value = false
  }
})

onUnmounted(() => {
  guide.hide('check_weight')
  stopTipTimer()
  unregisterPendingSave(pendingSaveKey)
  clearUnsaved(unsavedKey)
  if (draftTimer) { clearTimeout(draftTimer); draftTimer = null }
  if (draftable) clearDraft('meal')
  if (slowSaveTimer) { clearTimeout(slowSaveTimer); slowSaveTimer = null }
  if (editPhotoPreview.value) URL.revokeObjectURL(editPhotoPreview.value)
  document.body.style.position = ''
  document.body.style.top = ''
  document.body.style.left = ''
  document.body.style.right = ''
  document.body.style.overflow = ''
  window.scrollTo(0, savedScrollY)
})

// keep-alive: снимаем/восстанавливаем scroll lock при скрытии/показе
watch(() => props.hidden, (hidden) => {
  if (hidden) {
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.left = ''
    document.body.style.right = ''
    document.body.style.overflow = ''
  } else {
    document.body.style.position = 'fixed'
    document.body.style.top = `-${savedScrollY}px`
    document.body.style.left = '0'
    document.body.style.right = '0'
    document.body.style.overflow = 'hidden'
  }
})

// Отслеживание изменений для edit-режима
const hasChanges = computed(() => {
  if (props.mode !== 'edit') return true
  if (tagsDirty.value) return true
  return hasDishChanges.value
})
// Всё, кроме тегов: такая правка пересоздаёт записи блюда
const hasDishChanges = computed(() => {
  if (editPhotoBase64.value) return true
  if (dishName.value !== originalDishName.value) return true
  if (localItems.value.length !== originalItems.value.length) return true
  return localItems.value.some((item, i) => {
    const orig = originalItems.value[i]
    return !orig || item.name !== orig.name || item.weight_g !== orig.weight_g || item._ingredientsEdited
  })
})

// Проверка: изменил ли пользователь блюдо (имя, кол-во ингредиентов, вес, название ингредиента)
function isDishModified() {
  if (dishName.value !== originalDishName.value) return true
  if (localItems.value.length !== originalItems.value.length) return true
  return localItems.value.some((item, i) => {
    const orig = originalItems.value[i]
    return !orig || item.name !== orig.name || item.weight_g !== orig.weight_g || item._ingredientsEdited
  })
}

// Обновляем localItems когда данные приходят (после загрузки)
watch(() => props.items, (newItems) => {
  if (!newItems || newItems.length === 0) return
  stopTipTimer()

  // Первая загрузка — создаём localItems
  if (localItems.value.length === 0) {
    const totalW = newItems.reduce((s, i) => s + (i.weight_g || 0), 0) || 1
    localItems.value = newItems.map(item => {
      // Гарантируем per100: если пустой — вычисляем из абсолютных значений
      let per100 = item.per100
      if ((!per100 || per100.kcal == null) && item.weight_g > 0 && item.kcal > 0) {
        per100 = {
          kcal:    per100Of(item.kcal, item.weight_g),
          protein: per100Of(item.protein, item.weight_g),
          fat:     per100Of(item.fat, item.weight_g),
          carbs:   per100Of(item.carbs, item.weight_g),
          fiber:   per100Of(item.fiber, item.weight_g),
          water:   per100Of(item.water, item.weight_g),
        }
      }
      return {
        ...item,
        per100: per100 || {},
        _baseWeight: item.weight_g || 0,
        _baseVitamins: item.vitamins ? { ...item.vitamins } : null,
        _totalVitamins: item.vitamins ? { ...item.vitamins } : (item._totalVitamins || null),
        _dbSource: item._dbSource || item.source || null,
        ingredients: item.ingredients ? item.ingredients.map(ing => ({
          ...ing,
          _dbSource: ing._dbSource || ing.source || null,
        })) : undefined,
      }
    })
    confidenceVal.value = props.confidence
    if (props.mode === 'photo') {
      track('photo_recognized', { confidence: props.confidence, items_count: newItems.length })
    }
    // Подсказка Зои: вес — оценка, его стоит проверить (только у нового распознавания)
    if (props.mode === 'photo' || props.mode === 'text') {
      guide.journey('j_recognized', { src: props.voice ? 'voice' : props.mode, items: newItems.length })
      guide.request('check_weight', { anchor: '[data-guide="weight"]', place: 'below' })
    }
    // Инициализируем portionWeight
    if (props.isEditedCooking || props.cookedWeightG > 0 || (props.mode === 'edit' && newItems.length > 1)) {
      _rescaling = true
      _portionRef = portionRefFor(props.cookedWeightG, totalW)
      portionWeight.value = _portionRef
      nextTick(() => { _rescaling = false })
    }
    return
  }

  // Обновления от enrichAllItems — мержим per100/product_id/vitamins ингредиентов
  for (let i = 0; i < newItems.length && i < localItems.value.length; i++) {
    const src = newItems[i]
    const local = localItems.value[i]
    if (local._ingredientsEdited) continue

    let changed = false

    // Обновляем per100/КБЖУ item
    if (src.kcal != null && src.kcal !== local.kcal) {
      local.kcal = src.kcal; local.protein = src.protein; local.fat = src.fat
      local.carbs = src.carbs; local.fiber = src.fiber; local.water = src.water
      local.per100 = src.per100
      changed = true
    }
    if (src.product_id) { local.product_id = src.product_id; changed = true }
    if (src.db_name) { local.db_name = src.db_name; local.name = src.name; changed = true }
    if (src.matched != null) { local.matched = src.matched; changed = true }
    if (src._usedFallback != null) { local._usedFallback = src._usedFallback; changed = true }
    if (src._enrichFailed != null) { local._enrichFailed = src._enrichFailed; changed = true }
    if (src._totalVitamins) { local._totalVitamins = src._totalVitamins; changed = true }
    if (src._noVitamins) { local._noVitamins = src._noVitamins; changed = true }
    if (src._dbSource) { local._dbSource = src._dbSource; changed = true }
    // Раскладка крупы приходит тем же поздним обогащением, что и db_name,
    // и без неё карточка молча теряет и обе строки, и переключатель веса
    if (src._grain !== undefined) { local._grain = src._grain; changed = true }
    if (src._cooking !== undefined) { local._cooking = src._cooking; changed = true }
    if (src._grainParts !== undefined) { local._grainParts = src._grainParts; changed = true }

    // Мержим per100/product_id/vitamins ингредиентов
    if (local.ingredients?.length && src.ingredients?.length) {
      for (let j = 0; j < local.ingredients.length && j < src.ingredients.length; j++) {
        const srcIng = src.ingredients[j]
        const localIng = local.ingredients[j]
        if (srcIng.per100 && srcIng.per100.kcal != null) {
          localIng.per100 = { ...srcIng.per100 }
          changed = true
        }
        if (srcIng.product_id) localIng.product_id = srcIng.product_id
        if (srcIng.db_name) localIng.db_name = srcIng.db_name
        if (srcIng.vitamins) localIng.vitamins = srcIng.vitamins
        if (srcIng.matched != null) localIng.matched = srcIng.matched
        if (srcIng._dbSource) localIng._dbSource = srcIng._dbSource
        if (srcIng._grain !== undefined) { localIng._grain = srcIng._grain; changed = true }
        if (srcIng._cooking !== undefined) { localIng._cooking = srcIng._cooking; changed = true }
      }
    }

    if (changed) {
      localItems.value.splice(i, 1, { ...local })
    }
  }
})

// Карточка из одного продукта базы — тогда заменённое фото имеет смысл
// сохранить как фото продукта: тот же творог завтра добавят заново, и это
// будет уже другое блюдо, а ожидание у человека одно — «я поменял картинку».
// У блюда из нескольких ингредиентов фото принадлежит блюду, не продукту.
const singleProductId = computed(() => {
  if (localItems.value.length !== 1) return null
  return localItems.value[0]?.product_id || null
})

// Фото для отображения
const displayPhotoUrl = computed(() => {
  if (editPhotoPreview.value) return editPhotoPreview.value
  if (props.previewUrl) return props.previewUrl
  if (props.photoUrl) return props.photoUrl
  return null
})

// Название блюда — из Gemini prop или автогенерация (редактируемое)
const dishName = ref('')
const editingDishName = ref(false)
const dishNameInputRef = ref(null)

function initDishName() {
  if (props.dishNameProp) { dishName.value = props.dishNameProp }
  else if (localItems.value.length === 0) { dishName.value = '' }
  else if (localItems.value.length === 1) { dishName.value = localItems.value[0].name }
  else { dishName.value = localItems.value[0].name + ` и ещё ${localItems.value.length - 1}` }
  if (!originalDishName.value && dishName.value) originalDishName.value = dishName.value
  applyDraft()
}

// Восстановление после перезагрузки: название, время приёма, теги и ключи
// сохранения — те же, что были, поэтому повтор не создаст дубля, даже если
// первый ответ сервера потерялся за перезагрузкой
let draftApplied = false
function applyDraft() {
  const d = props.draft
  if (!d || draftApplied) return
  draftApplied = true
  if (d.dishName) dishName.value = d.dishName
  if (d.mealDate) mealDate.value = d.mealDate
  if (d.mealStartH != null) { mealStartH.value = d.mealStartH; mealStartM.value = d.mealStartM || 0 }
  if (d.mealEndH != null) { mealEndH.value = d.mealEndH; mealEndM.value = d.mealEndM || 0 }
  if (Array.isArray(d.tags) && d.tags.length) dishTags.value = d.tags
  if (d.recognitionId) currentRecognitionId.value = d.recognitionId
  if (d.saveClientId) saveClientId = d.saveClientId
}

// Черновик пишется по любому изменению ввода: позиции, название, время, теги
watch([localItems, dishName, mealDate, mealStartH, mealStartM, mealEndH, mealEndM, dishTags], scheduleDraft, { deep: true })

function startEditDishName() {
  editingDishName.value = true
  nextTick(() => {
    dishNameInputRef.value?.focus()
  })
}

// Инициализация при монтировании и при изменении dishNameProp
watch(() => props.dishNameProp, (val) => { if (val) dishName.value = val })
watch(localItems, (items) => {
  // Только если имя ещё не задано (первая загрузка)
  if (!dishName.value && items.length > 0) initDishName()
}, { deep: false })

onMounted(() => { if (localItems.value.length > 0 || props.dishNameProp) initDishName() })

// Режим порции: для рецептов (isEditedCooking) и repeat-блюд с cooked_weight_g
// Обычные фото-блюда НЕ показывают «Вес порции» — пользователь редактирует вес каждого ингредиента напрямую
const isPortionMode = computed(() => !!props.isEditedCooking || props.cookedWeightG > 0)
// Флаг: идёт программный пересчёт, не реагировать на watch portionWeight
let _rescaling = false
// Базовый вес порции (cookedWeightG или сумма весов) — для вычисления scale
let _portionRef = 0

// Суммарные КБЖУ — простая сумма localItems (ингредиенты уже масштабированы)
const totalKcal    = computed(() => Math.round(localItems.value.reduce((s, i) => s + (i.kcal || 0), 0)))
const totalProtein = computed(() => Math.round(localItems.value.reduce((s, i) => s + (i.protein || 0), 0)))
const totalFat     = computed(() => Math.round(localItems.value.reduce((s, i) => s + (i.fat || 0), 0)))
const totalCarbs   = computed(() => Math.round(localItems.value.reduce((s, i) => s + (i.carbs || 0), 0)))
// До десятых ниже 10 г — как на карточках дневника: порция клетчатки обычно
// пара граммов, и округление до целого съело бы половину значения.
const totalFiber   = computed(() => {
  const sum = localItems.value.reduce((s, i) => s + (i.fiber || 0), 0)
  return sum >= 10 ? Math.round(sum) : Math.round(sum * 10) / 10
})

// Отправная точка для масштабирования порции: вес, сохранённый у блюда, иначе
// сумма весов состава.
//
// Здесь рецепт работает шаблоном, и человек вправе взять от него сколько
// угодно: 65 г от блюда на 710 г — обычная небольшая порция, а не ошибка. На
// расхождение веса с составом смотрит только экран рецепта в «Кулинарии», где
// это действительно итог блюда, а не размер порции.
function portionRefFor(cookedWeightG, itemsTotal) {
  return Number(cookedWeightG) || Math.round(itemsTotal) || 0
}

// База для раздачи веса по суб-ингредиентам. Снимок делается в
// startEditPortionWeight и живёт, пока человек правит вес порции: пересчёт
// идёт на каждый набранный символ, и «250» — это ещё и «2», и «25». Считай мы
// от текущих весов, щепотка соли на промежуточном «2» округлилась бы до нуля и
// обратно уже не выросла.
function ingredientScaleBase(item) {
  return (item.ingredients || []).map(ing => (ing._portionBase != null ? ing._portionBase : (ing.weight_g || 0)))
}

// Всё, что описывает вес позиции, идёт за ним: веса суб-ингредиентов и их
// раскладка круп. Раньше этого не делал только пересчёт порции — состав
// раскрытого блюда оставался в граммах от прежнего веса. Причём не только на
// экране: addAll сохраняет доли ингредиентов как weight_g / вес позиции × 100,
// и от 150 г начинки в позиции на 75 г в блюдо уезжали доли, дающие в сумме
// 200 вместо 100.
function scaleItemIngredients(item, targetWeight, baseWeights) {
  const ings = item.ingredients
  const target = Number(targetWeight) || 0
  if (!ings?.length || !(target > 0)) return
  const base = baseWeights && baseWeights.length === ings.length
    ? baseWeights
    : ings.map(ing => ing.weight_g || 0)
  if (!(base.reduce((s, w) => s + (w || 0), 0) > 0)) return
  const weights = distributeWeights(base, target)
  ings.forEach((ing, i) => {
    ing.weight_g = weights[i]
    if (ing.nutrients) {
      ing.vitamins = extractVitaminsFromNutrients(ing.nutrients, ing.weight_g)
    }
    if (ing._grain) ing._grain = rescaleGrain(ing._grain, ing.weight_g)
    if (ing._cooking) ing._cooking = rescaleCooking(ing._cooking, ing.weight_g)
  })
}

// Раскладка крупы у самой позиции: _grain пересчитывается по коэффициенту
// разварки, а _grainParts — те же граммы, только с названиями продуктов, и
// берутся из него. Калории целиком в сухой части, вода их не добавляет —
// так же, как это собирает decompose() на сервере.
function scaleItemGrain(item, targetWeight) {
  // Ужарка привязана к весу так же: сырой вес = готовый ÷ yield
  if (item._cooking) item._cooking = rescaleCooking(item._cooking, targetWeight)
  if (!item._grain) return
  const target = Number(targetWeight) || 0
  item._grain = rescaleGrain(item._grain, target)
  const parts = item._grainParts
  if (!parts?.length) return
  const dryKcal = Math.round((item.per100?.kcal || 0) * target / 100 * 10) / 10
  const weights = [item._grain.dry_weight_g, item._grain.water_weight_g]
  item._grainParts = parts.map((part, i) => (
    weights[i] == null ? part : { ...part, weight_g: weights[i], kcal: i === 0 ? dryKcal : 0 }
  ))
}

// Масштабирование ингредиентов при изменении веса порции
// Используем сумму _baseWeight (а не _portionRef) как знаменатель,
// чтобы сумма масштабированных весов ~ newWeight
function rescaleToPortionWeight(newWeight) {
  if (!_portionRef) return
  _rescaling = true
  const scale = newWeight / _portionRef
  for (const item of localItems.value) {
    if (item._baseWeight == null) continue
    const newItemWeight = roundWeight(item._baseWeight * scale)
    const per100 = item.per100 || {}
    item.weight_g = newItemWeight
    item.kcal    = Math.round((per100.kcal || 0) * newItemWeight / 100 * 10) / 10
    item.protein = Math.round((per100.protein || 0) * newItemWeight / 100 * 10) / 10
    item.fat     = Math.round((per100.fat || 0) * newItemWeight / 100 * 10) / 10
    item.carbs   = Math.round((per100.carbs || 0) * newItemWeight / 100 * 10) / 10
    item.fiber   = per100.fiber ? Math.round((per100.fiber || 0) * newItemWeight / 100 * 10) / 10 : null
    item.water   = per100.water ? Math.round((per100.water || 0) * newItemWeight / 100 * 10) / 10 : null
    // Масштабируем витамины
    if (item._baseVitamins) {
      const scaledVit = {}
      for (const [k, v] of Object.entries(item._baseVitamins)) {
        scaledVit[k] = Math.round(v * scale * 100) / 100
      }
      item._totalVitamins = scaledVit
    }
    // Состав и раскладка круп внутри позиции — за её весом
    scaleItemIngredients(item, newItemWeight, ingredientScaleBase(item))
    scaleItemGrain(item, newItemWeight)
  }
  _rescaling = false
}

// Пересчитать _baseWeight и _portionRef при ручном изменении веса ингредиента
function updateBaseWeightsFromItems() {
  // Пересчитываем _portionRef пропорционально изменению суммы весов
  const oldTotalRaw = localItems.value.reduce((s, i) => s + (i._baseWeight || 0), 0) || 1
  const newTotalRaw = localItems.value.reduce((s, i) => s + (i.weight_g || 0), 0) || 1
  const ratio = newTotalRaw / oldTotalRaw
  for (const item of localItems.value) {
    item._baseWeight = item.weight_g || 0
    item._baseVitamins = item._totalVitamins ? { ...item._totalVitamins } : null
  }
  _rescaling = true
  _portionRef = Math.round(_portionRef * ratio) || portionWeight.value || newTotalRaw
  portionWeight.value = _portionRef
  // Сбрасываем _rescaling в nextTick, чтобы асинхронный watcher portionWeight
  // не вызвал rescaleToPortionWeight и не перезаписал только что введённый вес
  nextTick(() => { _rescaling = false })
}

// Сумма весов состава — точка отсчёта для структурных изменений
function compositionTotal() {
  return localItems.value.reduce((s, i) => s + (i.weight_g || 0), 0)
}

// Продукт добавили или убрали из состава — вес порции меняется ровно на его вес.
//
// Пропорциональный пересчёт (updateBaseWeightsFromItems) здесь не годится: доля
// «сколько уварилось» описывает тот состав, который готовили, и на досыпанное
// сверху не распространяется — 100 г клубники в творог это плюс 100 г порции,
// а не повод перетряхнуть всё блюдо. Раньше добавление вообще не двигало вес
// порции: новый item приходил в список с уже проставленным _baseWeight, база и
// новая сумма совпадали, ratio выходил 1. Порция оставалась от прежнего состава
// (310 г при составе 410 г), и следующая же правка веса ингредиента считала
// пропорцию от этой лжи: 310 × 360/410 = 272 г.
function shiftPortionByComposition(totalBefore) {
  const totalAfter = compositionTotal()
  for (const item of localItems.value) {
    item._baseWeight = item.weight_g || 0
    item._baseVitamins = item._totalVitamins ? { ...item._totalVitamins } : null
  }
  _rescaling = true
  const shifted = Math.round((Number(portionWeight.value) || 0) + (totalAfter - totalBefore))
  _portionRef = shifted > 0 ? shifted : (Math.round(totalAfter) || 0)
  portionWeight.value = _portionRef
  // Как и в updateBaseWeightsFromItems: снимаем флаг в nextTick, чтобы watcher
  // portionWeight не откатил только что посчитанные веса.
  nextTick(() => { _rescaling = false })
}

watch(portionWeight, (val) => {
  if (isPortionMode.value && !_rescaling && val > 0) rescaleToPortionWeight(val)
})

// Редактирование веса item
function startEditPortionWeight() {
  editingPortionWeight.value = true
  // Снимок пропорций состава на всю правку: см. ingredientScaleBase
  for (const item of localItems.value) {
    for (const ing of item.ingredients || []) ing._portionBase = ing.weight_g || 0
  }
  nextTick(() => {
    const el = portionWeightInputRef.value
    if (el) { el.focus(); el.select() }
  })
}

const portionWeightError = ref('')
function finishEditPortionWeight() {
  const val = portionWeight.value
  if (!val || val <= 0 || isNaN(val)) {
    portionWeightError.value = 'Размер порции не может быть равен 0. Укажите размер в граммах.'
    // Восстанавливаем предыдущее значение
    portionWeight.value = _portionRef || 1
    setTimeout(() => { portionWeightError.value = '' }, 3000)
  }
  editingPortionWeight.value = false
  // Снимок пропорций больше не нужен: следующая правка снимет свой
  for (const item of localItems.value) {
    for (const ing of item.ingredients || []) ing._portionBase = null
  }
}

function editWeight(idx, field = 'g') {
  guide.done('check_weight')
  const item = localItems.value[idx]
  if (item) item._prevWeight = item.weight_g
  editField.value = field
  editingIdx.value = idx
  nextTick(() => {
    const inputs = weightInputRef.value
    if (Array.isArray(inputs) && inputs[0]) inputs[0].focus()
    else if (inputs) inputs.focus()
  })
}

function finishEditWeight(item) {
  editingIdx.value = -1
  // Состав раздаём по новому весу от собственной суммы, а не по отношению к
  // _prevWeight: если вес позиции пришёл со стороны (пересчёт порции), состав
  // мог остаться от прежнего, и множитель от _prevWeight растащил бы его ещё
  // дальше. От суммы — сходится всегда.
  scaleItemIngredients(item, item.weight_g)
  scaleItemGrain(item, item.weight_g)
  item._prevWeight = item.weight_g
  recalc(item)
  // В режиме порции: обновить вес порции = сумма весов ингредиентов
  if (isPortionMode.value) updateBaseWeightsFromItems()
}

// Раскладка крупы привязана к весу: 180 г готовой пасты это 75 г сухой, а
// 200 г — уже 83,3. Вес правится в трёх местах, и без пересчёта строка
// «75 г сухих + 105 г воды» оставалась от прежнего числа. Связь линейная,
// коэффициент разварки лежит в самих метаданных — повторяет decompose().
function rescaleGrain(grain, weightG) {
  if (!grain) return null
  const w = parseFloat(weightG) || 0
  const h = Number(grain.hydration) || 1
  const r1 = (v) => Math.round(v * 10) / 10
  const dry = grain.basis === 'dry' ? w : w / h
  const cooked = grain.basis === 'dry' ? w * h : w
  return { ...grain, dry_weight_g: r1(dry), water_weight_g: r1(cooked - dry), cooked_weight_g: r1(cooked) }
}

// Ужарка мяса и рыбы (lib/cooking.js): сырой вес = готовый ÷ yield, per100
// уже посчитан для готового продукта и от веса не зависит. Пересчитываем
// только граммы в подсказке.
function rescaleCooking(cooking, weightG) {
  if (!cooking) return null
  const w = parseFloat(weightG) || 0
  const y = Number(cooking.yield) || 1
  const r1 = (v) => Math.round(v * 10) / 10
  return { ...cooking, cooked_weight_g: r1(w), raw_weight_g: r1(w / y) }
}

// «сырого ~143 г · ужарка 30%»; при варке и на пару — уварка.
function cookingHint(cooking) {
  if (!cooking) return ''
  // Готовая карточка-двойник без оценки сырого веса (категория без коэффициента)
  if (cooking.raw_weight_g == null) return 'по карточке готового продукта'
  const pct = Math.round((1 - (Number(cooking.yield) || 1)) * 100)
  const word = cooking.method === 'boiling' || cooking.method === 'steaming' ? 'уварка' : 'ужарка'
  return `сырого ~${fmtG(cooking.raw_weight_g)} г · ${word} ${pct}%`
}

function ensurePer100(item) {
  if (item.per100?.kcal != null) return
  const prev = item._prevWeight
  if (!prev || prev <= 0) return
  item.per100 = {
    kcal:    (item.kcal || 0) / prev * 100,
    protein: (item.protein || 0) / prev * 100,
    fat:     (item.fat || 0) / prev * 100,
    carbs:   (item.carbs || 0) / prev * 100,
    fiber:   (item.fiber || 0) / prev * 100,
    water:   (item.water || 0) / prev * 100,
  }
}

function recalc(item) {
  if (item.ingredients?.length) {
    recalcFromIngredients(item)
    return
  }
  ensurePer100(item)
  const w = item.weight_g || 0
  const calc = (per100) => per100 != null ? Math.round(per100 * w / 100 * 10) / 10 : null
  item.kcal    = calc(item.per100?.kcal)
  item.protein = calc(item.per100?.protein)
  item.fat     = calc(item.per100?.fat)
  item.carbs   = calc(item.per100?.carbs)
  item.fiber   = calc(item.per100?.fiber)
  item.water   = calc(item.per100?.water)
  // Пересчитать витамины по соотношению весов
  if (item._totalVitamins && item._prevWeight && item._prevWeight > 0 && w !== item._prevWeight) {
    const ratio = w / item._prevWeight
    const scaledVit = {}
    for (const [k, v] of Object.entries(item._totalVitamins)) {
      if (k === '_no_vitamins') { scaledVit[k] = v; continue }
      scaledVit[k] = Math.round(v * ratio * 100) / 100
    }
    item._totalVitamins = scaledVit
  }
}

function recalcFromIngredients(item, updateWeight = false) {
  const hasValidPer100 = item.ingredients.some(ing => ing.per100?.kcal > 0)

  if (!hasValidPer100) {
    // Ни один ингредиент не имеет per100 — вычисляем per100 блюда из текущих КБЖУ
    ensurePer100(item)
    if (item.per100?.kcal > 0) {
      for (const ing of item.ingredients) {
        if (!ing.per100?.kcal) {
          ing.per100 = { ...item.per100 }
        }
      }
    }
  }

  let kcal = 0, protein = 0, fat = 0, carbs = 0, fiber = 0, water = 0
  for (const ing of item.ingredients) {
    const w = ing.weight_g || 0
    const p = ing.per100 || {}
    if (ing._grain) ing._grain = rescaleGrain(ing._grain, w)
    if (ing._cooking) ing._cooking = rescaleCooking(ing._cooking, w)
    kcal    += (p.kcal || 0) * w / 100
    protein += (p.protein || 0) * w / 100
    fat     += (p.fat || 0) * w / 100
    carbs   += (p.carbs || 0) * w / 100
    fiber   += (p.fiber || 0) * w / 100
    water   += (p.water || 0) * w / 100
  }
  item.kcal    = Math.round(kcal * 10) / 10
  item.protein = Math.round(protein * 10) / 10
  item.fat     = Math.round(fat * 10) / 10
  item.carbs   = Math.round(carbs * 10) / 10
  item.fiber   = Math.round(fiber * 10) / 10
  item.water   = Math.round(water * 10) / 10
  // Обновляем weight_g только при ручном редактировании ингредиентов
  if (updateWeight) {
    item.weight_g = item.ingredients.reduce((s, ing) => s + (ing.weight_g || 0), 0)
  }
  // Обновляем per100 блюда из пересчитанных ингредиентов
  const w = item.weight_g || 1
  item.per100 = {
    kcal:    per100Of(kcal, w),
    protein: per100Of(protein, w),
    fat:     per100Of(fat, w),
    carbs:   per100Of(carbs, w),
    fiber:   per100Of(fiber, w),
    water:   per100Of(water, w),
  }
  // Пересчитываем суммарные витамины из ингредиентов
  const totalVit = {}
  for (const ing of item.ingredients) {
    // Если есть nutrients JSONB — пересчитываем витамины по актуальному весу
    if (ing.nutrients) {
      ing.vitamins = extractVitaminsFromNutrients(ing.nutrients, ing.weight_g || 0)
    }
    if (!ing.vitamins) continue
    for (const [key, val] of Object.entries(ing.vitamins)) {
      totalVit[key] = Math.round(((totalVit[key] || 0) + val) * 100) / 100
    }
  }
  item._totalVitamins = Object.keys(totalVit).length > 0 ? totalVit : null
}

// Редактирование веса ингредиента
function editIngWeight(itemIdx, ingIdx) {
  const item = localItems.value[itemIdx]
  const ing = item?.ingredients?.[ingIdx]
  if (ing) ing._prevWeight = ing.weight_g  // сохраняем старый вес ИНГРЕДИЕНТА
  editingIngIdx.value = `${itemIdx}-${ingIdx}`
  nextTick(() => {
    const inputs = ingWeightInputRef.value
    if (Array.isArray(inputs) && inputs[0]) inputs[0].focus()
    else if (inputs) inputs.focus()
  })
}

function finishEditIngWeight(item, itemIdx) {
  editingIngIdx.value = ''
  item._ingredientsEdited = true
  recalcFromIngredients(item, true)
  // recalcFromIngredients только что переписал вес позиции суммой состава, то
  // есть изменился и вес всего блюда — вес порции обязан пойти следом, как при
  // правке веса самой позиции.
  if (isPortionMode.value) updateBaseWeightsFromItems()
}

function removeIngredient(itemIdx, ingIdx) {
  const item = localItems.value[itemIdx]
  if (!item?.ingredients) return
  expandedSubIngIdx.value = ''
  const totalBefore = compositionTotal()
  item.ingredients.splice(ingIdx, 1)
  item._ingredientsEdited = true
  if (item.ingredients.length > 0) {
    recalcFromIngredients(item, true)
  } else {
    // Все ингредиенты удалены — оставляем item как есть
    item.ingredients = undefined
  }
  if (isPortionMode.value && localItems.value.length > 0) shiftPortionByComposition(totalBefore)
}

// Получить ингредиенты для отображения (из Gemini или из recipeIngredients кэша)
function getIngredients(item, idx) {
  if (item.ingredients?.length) return item.ingredients
  const key = item.name.trim().toLowerCase()
  const cached = recipeIngredients.value[key]
  // Кэш валиден только если ингредиенты имеют per100 (старые записи vitaminEnricher — без per100)
  const cacheHasPer100 = cached?.some(ing => ing.per100?.kcal > 0)
  if (cached?.length && cacheHasPer100) {
    // Преобразуем формат рецепта (weight_per_100g) в формат ингредиентов (weight_g)
    const dw = item.weight_g || 100
    item.ingredients = cached.map(ing => ({
      name: ing.name,
      weight_g: Math.round((ing.weight_per_100g || 0) * dw / 100),
      per100: ing.per100 || {},
      product_id: ing.product_id || null,
      db_name: ing.db_name || null,
      _dbSource: ing.source || ing._dbSource || null,
      matched: ing.matched != null ? ing.matched : true,
      _grain: ing.grain || null,
      _cooking: ing.cooking || null,
    }))
    // Корректируем округление
    const cSum = item.ingredients.reduce((s, ing) => s + ing.weight_g, 0)
    const cDiff = dw - cSum
    if (cDiff !== 0 && item.ingredients.length > 0) {
      const heaviest = item.ingredients.reduce((a, b) => (a.weight_g >= b.weight_g ? a : b))
      heaviest.weight_g += cDiff
    }
    // Вес пришёл из доли рецепта и почти всегда отличается от того, для
    // которого раскладку считали при распознавании.
    for (const ing of item.ingredients) {
      if (ing._grain) ing._grain = rescaleGrain(ing._grain, ing.weight_g)
      if (ing._cooking) ing._cooking = rescaleCooking(ing._cooking, ing.weight_g)
    }
    return item.ingredients
  }
  return null
}

function removeItem(idx) {
  expandedIngIdx.value = -1
  const totalBefore = compositionTotal()
  localItems.value.splice(idx, 1)
  if (isPortionMode.value && localItems.value.length > 0) shiftPortionByComposition(totalBefore)
}

// Корректировка через ИИ
async function sendCorrection() {
  if (!correction.value.trim() || refining.value) return
  if (!authStore.hasAiAccess) { authStore.showPaywall = true; return }
  if (authStore.tokenLimitReached) { authStore.showTokenWarning = true; return }
  refining.value = true

  try {
    const currentItems = localItems.value.map(i => ({
      name: i.name,
      type: i.type || 'recipe',
      weight_g: i.weight_g,
      cooking_method: i.cooking_method || 'raw',
      ingredients: i.ingredients?.map(ing => ({ name: ing.name, weight_g: ing.weight_g })) || [],
    }))

    const prompt = `Ты — эксперт-диетолог. Вот текущий состав блюда:
${JSON.stringify(currentItems, null, 2)}

Пользователь просит: "${correction.value.trim()}"

Обнови состав и верни ответ СТРОГО в формате JSON (без markdown, без \`\`\`):
{
  "items": [
    {
      "name": "Борщ", "type": "recipe", "weight_g": 300, "cooking_method": "boiling",
      "fallback_kbju": {"kcal": 180, "protein": 8, "fat": 7, "carbs": 18},
      "ingredients": [
        {"name": "Свёкла", "weight_g": 45},
        {"name": "Картофель", "weight_g": 40},
        {"name": "Говядина", "weight_g": 50},
        {"name": "Вода", "weight_g": 100}
      ]
    },
    {
      "name": "Вино красное", "type": "direct", "weight_g": 150, "cooking_method": "raw",
      "fallback_kbju": {"kcal": 102, "protein": 0.1, "fat": 0, "carbs": 2.6},
      "ingredients": []
    }
  ]
}

Правила:
- Учти пожелание пользователя: добавь/убери/измени ингредиенты или вес
- type: "recipe" для блюд с декомпозицией, "direct" для напитков, упаковок, простых продуктов
- fallback_kbju: для КАЖДОГО item — твоя оценка КБЖУ на ВЕСЬ weight_g (kcal, protein, fat, carbs)
- name: конкретное название на русском языке как в таблице Скурихина
- weight_g: вес в граммах (целое число)
- cooking_method: для КАЖДОГО item — raw, boiling, frying, baking, steaming, stewing
- ingredients для type="recipe": базовые продукты с именами как в таблице Скурихина.
  Вес каждого — такой, какой он занимает в ГОТОВОМ блюде. Крупы, макароны и бобовые указывай тоже варёным весом, а не сухим
- ingredients для type="direct": пустой массив []
- Сумма weight_g ингредиентов ДОЛЖНА равняться weight_g блюда
- Обязательно включай воду/бульон для жидких блюд
- Верни весь обновлённый список (не только изменения)`

    const parts = [{ text: prompt }]

    // Если есть base64 фото — добавляем его для контекста
    if (props.photoBase64) {
      parts.push({ inline_data: { mime_type: props.photoMime, data: props.photoBase64 } })
    }

    const sendCorrection = async (job, retriesLeft = 2) => {
      const probe = startNetProbe()
      try {
        const { data } = await api.post(`/ai/gemini-proxy?model=gemini-2.5-flash&label=/photo/correction&pv=${CORRECTION_PROMPT_VERSION}&rid=${currentRecognitionId.value || ''}&job=${job}`, {
          contents: [{ parts }],
        }, { timeout: 120000 })
        probe.done()
        return data
      } catch (err) {
        // isAxiosError обязателен. Без него сюда попадала любая ошибка нашего же
    // кода, брошенная после успешного ответа: отсутствие err.response читалось
    // как «сети нет». Так опечатка в auth-store (вызов функции, переименованной
    // в другом коммите) три недели выглядела сетевым сбоем, трижды повторяла
    // запрос и жгла токены Gemini на ответах, которые уже пришли.
    const isNetwork = !err.response && err.isAxiosError === true
        const is429 = err.response?.status === 429
        // Сообщаем и о сбое сети, и об исключении своего кода: ответа нет ни в
        // том, ни в другом случае, а отличить их можно только по коду в отчете.
        // Повторяем при этом лишь сетевые — см. isNetwork выше.
        if (!err.response) probe.lost('/photo/correction', err, 3 - retriesLeft)
        else probe.done()
        if (retriesLeft > 0 && (is429 || isNetwork)) {
          await new Promise(r => setTimeout(r, 3000))
          return sendCorrection(job, retriesLeft - 1)
        }
        if (isNetwork) {
          throw new Error('Не дождались ответа — попробуйте ещё раз')
        }
        throw new Error(err.response?.data?.error?.message || err.message || 'Gemini error')
      }
    }

    const result = await withAiJob(job => sendCorrection(job))
    if (result?.zoya_recognition_id) currentRecognitionId.value = result.zoya_recognition_id

    // Расход токенов считает сервер по ответу Gemini (метка — в query
    // запроса выше); здесь только обновление индикатора бюджета.
    authStore.fetchTokenBudget()

    const text = result.candidates?.[0]?.content?.parts?.[0]?.text?.trim() || ''
    const cleaned = text.replace(/```json\n?/g, '').replace(/```\n?/g, '').trim()
    const parsed = JSON.parse(cleaned)

    if (parsed.items && parsed.items.length > 0) {
      // Создаём items без КБЖУ (будут заполнены после enrich)
      const newItems = parsed.items.map(item => {
        const itemType = item.type || 'recipe'
        const ingredients = itemType === 'direct' ? [] : (item.ingredients || []).map(ing => ({
          name: ing.name,
          weight_g: ing.weight_g || 0,
          product_id: null,
          per100: {},
        }))
        // Корректируем округление весов
        const dishWeight = item.weight_g || 100
        if (ingredients.length > 0) {
          const ingSum = ingredients.reduce((s, ing) => s + ing.weight_g, 0)
          const diff = dishWeight - ingSum
          if (diff !== 0) {
            const heaviest = ingredients.reduce((a, b) => (a.weight_g >= b.weight_g ? a : b))
            heaviest.weight_g += diff
          }
        }
        return {
          name: item.name,
          type: itemType,
          weight_g: dishWeight,
          cooking_method: item.cooking_method || 'raw',
          fallback_kbju: item.fallback_kbju || null,
          ingredients,
          product_id: null,
          db_name: null,
          kcal: null, protein: null, fat: null, carbs: null, fiber: null, water: null,
          per100: {},
        }
      })
      localItems.value = newItems
      correction.value = ''

      // Обогащаем КБЖУ + витамины из БД — маршрутизация по type
      localEnriching.value = true
      await Promise.all(newItems.map(enrichOne))
      // Установить _baseVitamins для корректного rescaleToPortionWeight
      for (const item of newItems) {
        if (item._totalVitamins && !item._baseVitamins) {
          item._baseVitamins = { ...item._totalVitamins }
          item._baseWeight = item._baseWeight || item.weight_g || 0
        }
      }
      localItems.value = [...newItems]
      localEnriching.value = false
    }
  } catch (err) {
    localEnriching.value = false
    console.error('Refine error:', err)
    const msg = err.message || ''
    if (msg.includes('429') || msg.includes('Resource exhausted')) {
      alert('Сервис распознавания временно перегружен. Попробуйте через несколько секунд.')
    } else {
      alert('Не удалось обновить состав. Попробуйте ещё раз.')
    }
  } finally {
    refining.value = false
  }
}

// Обогащение одного блюда или продукта из базы: direct-lookup или
// recipe-lookup по type. Ошибка сети больше не глотается молча: ставим
// _enrichFailed, по нему карточка показывает «Повторить», а «Добавить в
// Дневник» — предупреждение о нулях. 25.09.2026 у пользователя два
// recipe-lookup не дошли до сервера сразу после распознавания, и в дневник
// молча ушли нули с красным составом.
async function enrichOne(item) {
  item._enrichFailed = false
  try {
    if (item.type === 'direct') {
      // direct-lookup
      const requestWeight = item.weight_g
      const { data } = await api.post('/ai/direct-lookup', {
        name: item.name,
        weight_g: requestWeight,
        cooking_method: item.cooking_method || 'raw',
        fallback_kbju: item.fallback_kbju || null,
      }, { idempotent: true })
      item.product_id = data.product_id
      item.db_name = data.db_name
      item._grainParts = data.components || null
      item._grain = data.grain || null
      item._cooking = data.cooking || null
      item.per100 = data.per100
      // Пересчитываем КБЖУ и витамины по ТЕКУЩЕМУ весу (мог измениться пока шёл запрос)
      const currentWeight = item.weight_g
      const calc = (v) => v != null ? Math.round(v * currentWeight / 100 * 10) / 10 : null
      item.kcal = calc(data.per100?.kcal)
      item.protein = calc(data.per100?.protein)
      item.fat = calc(data.per100?.fat)
      item.carbs = calc(data.per100?.carbs)
      item.fiber = calc(data.per100?.fiber)
      item.water = calc(data.per100?.water)
      // Витамины: API вернул для requestWeight, пересчитываем на currentWeight
      let vit = data.vitamins && Object.keys(data.vitamins).length > 0 ? data.vitamins : null
      if (vit && requestWeight > 0 && currentWeight !== requestWeight) {
        const ratio = currentWeight / requestWeight
        const rescaled = {}
        for (const [k, v] of Object.entries(vit)) {
          if (k === '_no_vitamins') { rescaled[k] = v; continue }
          rescaled[k] = Math.round(v * ratio * 100) / 100
        }
        vit = rescaled
      }
      item._totalVitamins = vit
      if (data._no_vitamins?.length) item._noVitamins = data._no_vitamins
      item._usedFallback = data._usedFallback || false
      item.matched = data.matched
      if (data.source) item._dbSource = data.source
    } else {
      // recipe-lookup
      if (!item.ingredients?.length) return
      const { data } = await api.post('/ai/recipe-lookup', {
        items: item.ingredients.map(ing => ({ name: ing.name, weight_g: ing.weight_g })),
        cooking_method: item.cooking_method || 'raw',
        dish_name: item.name,
        fallback_kbju: item.fallback_kbju || null,
      }, { idempotent: true })
      if (data.items) {
        for (let i = 0; i < item.ingredients.length && i < data.items.length; i++) {
          const enriched = data.items[i]
          item.ingredients[i].per100 = enriched.per100
          item.ingredients[i].product_id = enriched.product_id
          item.ingredients[i].db_name = enriched.db_name
          item.ingredients[i]._grain = enriched.grain || null
          item.ingredients[i]._cooking = enriched.cooking || null
          item.ingredients[i].vitamins = enriched.vitamins || {}
          item.ingredients[i].matched = enriched.matched
          if (enriched.source) item.ingredients[i]._dbSource = enriched.source
        }
      }
      recalcFromIngredients(item)
      // Restore API-calculated vitamins (with retention factors) —
      // recalcFromIngredients may have overwritten them with empty sums
      if (data.total_vitamins) item._totalVitamins = data.total_vitamins
      if (data.no_vitamins?.length) item._noVitamins = data.no_vitamins
      // fallback если всё по нулям
      if ((item.kcal === 0 || item.kcal == null) && data._usedFallback && item.fallback_kbju) {
        item.kcal = Math.round((item.fallback_kbju.kcal || 0) * 10) / 10
        item.protein = Math.round((item.fallback_kbju.protein || 0) * 10) / 10
        item.fat = Math.round((item.fallback_kbju.fat || 0) * 10) / 10
        item.carbs = Math.round((item.fallback_kbju.carbs || 0) * 10) / 10
        item._usedFallback = true
      }
    }
  } catch (err) {
    console.error('Enrich error for', item.name, err)
    item._enrichFailed = true
  }
  if (item._totalVitamins && !item._baseVitamins) {
    item._baseVitamins = { ...item._totalVitamins }
    item._baseWeight = item._baseWeight || item.weight_g || 0
  }
}

const retryingIdx = ref(null)
const zeroWarnItems = ref([])

async function retryEnrich(i) {
  const item = localItems.value[i]
  if (!item) return
  retryingIdx.value = i
  try { await enrichOne(item) }
  finally {
    retryingIdx.value = null
    localItems.value.splice(i, 1, { ...item })
  }
}

async function retryAllFailed() {
  zeroWarnItems.value = []
  const idx = localItems.value.map((it, i) => it._enrichFailed ? i : -1).filter(i => i >= 0)
  await Promise.all(idx.map(retryEnrich))
}

// Избранное
async function toggleFavorite() {
  if (props.dishId) {
    // Dish уже существует — сразу обновляем в БД
    try {
      const { data } = await api.patch(`/diary/dishes/${props.dishId}/favorite`)
      isFavorite.value = data.is_favorite
      emit('favorite-toggled', { dishId: props.dishId, isFavorite: data.is_favorite })
    } catch (err) {
      console.error('Toggle favorite error:', err)
    }
  } else {
    // Dish ещё не создан — переключаем локально, синхронизируем при сохранении
    isFavorite.value = !isFavorite.value
  }
  track('dish_favorited', { is_favorite: isFavorite.value })
}

// Удалить блюдо (edit-режим)
async function deleteDish() {
  deletingDish.value = true
  try {
    for (const id of props.entryIds) {
      await api.delete(`/diary/${id}`)
    }
    emit('deleted', props.entryIds)
    emit('close')
  } catch (err) {
    alert(err.response?.data?.error || 'Ошибка удаления')
  } finally {
    deletingDish.value = false
  }
}

// Добавить / сохранить все в дневник
async function addAll(force = false) {
  // Изменились только теги — сохраняем их и закрываем: пересоздавать записи
  // блюда ради тегов незачем.
  if (props.mode === 'edit' && tagsDirty.value && !hasDishChanges.value) {
    addingAll.value = true
    try {
      await saveTagsNow(dishTags.value)
      emit('close')
    } catch (err) {
      console.error('Save tags error:', err)
    } finally {
      addingAll.value = false
    }
    return
  }
  // Нули из-за несработавшего подбора не сохраняем молча: сначала предупреждение
  const failed = localItems.value.filter(it => it._enrichFailed).map(it => it.name)
  if (failed.length && force !== true) { zeroWarnItems.value = failed; return }
  zeroWarnItems.value = []
  addingAll.value = true
  saveError.value = ''
  unregisterPendingSave(pendingSaveKey)
  slowSave.value = false
  if (slowSaveTimer) clearTimeout(slowSaveTimer)
  slowSaveTimer = setTimeout(() => { slowSave.value = true }, 5000)
  const now = new Date().toISOString()
  const added = []

  try {
    // Edit-режим: старые записи НЕ удаляем заранее. До 14.10.2026 они уходили
    // по одной через DELETE ещё до сохранения новых, и зависание приложения
    // между этими шагами оставляло человека без приёма (пользователь 11931).
    // Теперь их id едут в пакет replace_entry_ids, и сервер удаляет старое в
    // той же транзакции, где создаёт новое: либо прежняя версия, либо новая.

    // Загружаем фото в S3 (только для photo-режима)
    let photoUrl = props.photoUrl || null
    if (props.mode === 'photo' && props.photoBase64) {
      try {
        const { data } = await api.post('/diary/upload-photo', {
          base64:   props.photoBase64,
          mimeType: props.photoMime,
        })
        photoUrl = data.url
      } catch (uploadErr) {
        console.error('S3 upload failed:', uploadErr.response?.data?.error || uploadErr.message)
      }
    }
    // Загружаем фото в S3 (edit-режим, новое фото из камеры/галереи)
    if (props.mode === 'edit' && editPhotoBase64.value) {
      try {
        const { data } = await api.post('/diary/upload-photo', {
          base64:   editPhotoBase64.value,
          mimeType: editPhotoMime.value,
        })
        photoUrl = data.url

        // Карточка из одного продукта базы: то же фото становится личным фото
        // продукта. Иначе замена жила бы ровно до следующего добавления того
        // же творога — человек менял картинку не для одного дня.
        if (singleProductId.value) {
          try {
            await api.put(`/products/${singleProductId.value}/my-photo`, { photo_url: data.url })
          } catch (photoErr) {
            console.error('Product photo save failed:', photoErr.response?.data?.error || photoErr.message)
          }
        }
      } catch (uploadErr) {
        console.error('S3 upload failed:', uploadErr.response?.data?.error || uploadErr.message)
      }
    }

    // Возврат к картинке из базы: снимаем личное фото и не тащим старую
    // ссылку в новые записи — иначе она осталась бы в photo_url карточки.
    if (props.mode === 'edit' && resetProductPhoto.value && singleProductId.value) {
      try {
        const { data } = await api.delete(`/products/${singleProductId.value}/my-photo`)
        photoUrl = data.photo_url || null
      } catch (resetErr) {
        console.error('Product photo reset failed:', resetErr.response?.data?.error || resetErr.message)
      }
    }

    // Рассчитываем recipe totals из localItems для хранения в zoya_dishes
    const recipeTotals = {
      recipe_total_kcal:    Math.round(localItems.value.reduce((s, i) => s + (i.kcal || 0), 0) * 10) / 10,
      recipe_total_protein: Math.round(localItems.value.reduce((s, i) => s + (i.protein || 0), 0) * 10) / 10,
      recipe_total_fat:     Math.round(localItems.value.reduce((s, i) => s + (i.fat || 0), 0) * 10) / 10,
      recipe_total_carbs:   Math.round(localItems.value.reduce((s, i) => s + (i.carbs || 0), 0) * 10) / 10,
      recipe_ingredients_weight: Math.round(localItems.value.reduce((s, i) => s + (i.weight_g || 0), 0) * 10) / 10,
    }

    // Build dish ingredients with sub-ingredient structure for persistence
    const totalItemsWeight = localItems.value.reduce((s, i) => s + (i.weight_g || 0), 0) || 1
    const dishIngredients = localItems.value.map(item => {
      const w = item.weight_g || 0
      const itemPer100 = (item.per100 && item.per100.kcal != null) ? item.per100 : (w > 0 ? {
        kcal:    per100Of(item.kcal, w),
        protein: per100Of(item.protein, w),
        fat:     per100Of(item.fat, w),
        carbs:   per100Of(item.carbs, w),
        fiber:   per100Of(item.fiber, w),
        water:   per100Of(item.water, w),
      } : {})
      const result = {
        name: item.name,
        weight_per_100g: totalItemsWeight > 0 ? Math.round(w / totalItemsWeight * 100 * 10) / 10 : 0,
        weight_g: w,
        per100: itemPer100,
        product_id: item.product_id || null,
        db_name: item.db_name || null,
        source: item._dbSource || item._source || null,
        // Откуда цифры у позиции без карточки: 'ai' — оценка модели, 'label' —
        // этикетка. Без этого при повторном открытии блюда метка «ИИ» пропадала,
        // и позиция выглядела ненайденной
        estimate: item.product_id ? null : item._usedFallback ? 'ai' : item._hasLabelData ? 'label' : null,
        // Раскладка крупы или пасты на сухую часть и воду. Раньше жила только
        // в памяти компонента и терялась при сохранении, из-за чего при
        // повторном открытии блюда «35 г макарон» выглядели как сухие, хотя
        // КБЖУ уже посчитаны от 14,6 г сухих плюс впитанная вода.
        grain: item._grain || null,
        grain_components: item._grainParts || null,
        // Ужарка: вес готовый, карточка сырая — без этого при повторном
        // открытии подсказка про сырой вес пропадала бы.
        cooking: item._cooking || null,
      }
      if (item.ingredients?.length > 0) {
        result.ingredients = item.ingredients.map(ing => ({
          name: ing.name,
          weight_per_100g: w > 0 ? Math.round((ing.weight_g || 0) / w * 100 * 10) / 10 : 0,
          weight_g: ing.weight_g || 0,
          per100: ing.per100 || {},
          product_id: ing.product_id || null,
          db_name: ing.db_name || null,
          source: ing._dbSource || ing._source || null,
          grain: ing._grain || null,
          cooking: ing._cooking || null,
        }))
        if (item.cooking_method) result.cooking_method = item.cooking_method
      }
      return result
    })

    // Repeat без изменений — переиспользуем оригинальный dish_id.
    // Repeat с изменениями / edit / новое блюдо — создаём копию (copy-on-write).
    const isUnmodifiedRepeat = props.mode === 'repeat' && props.dishId && !isDishModified()
    let dishPayload = null
    if (!isUnmodifiedRepeat) {
      dishPayload = {
        name: dishName.value || localItems.value[0]?.name || 'Блюдо',
        photo_url: photoUrl,
        ingredients: dishIngredients,
      }
      // Для рецептов (isEditedCooking) не сохраняем recipe_totals —
      // localItems содержат масштабированные значения порции, а не оригинального рецепта
      if (!(props.mode === 'edit' && props.isEditedCooking)) {
        Object.assign(dishPayload, recipeTotals)
      }
      if (isPortionMode.value && portionWeight.value) {
        dishPayload.cooked_weight_g = portionWeight.value
        // Рецепты создаются только явно на странице Cooking.
        // PhotoRecognizeDialog — это дневник: ни photo, ни text, ни edit, ни repeat
        // не должны попадать в «Мои рецепты».
        dishPayload.is_edited_cooking = false
      } else if (props.mode === 'edit') {
        // Обычные блюда (не рецепты): обнулить cooked_weight_g,
        // чтобы MealGroup использовал сумму весов entries
        dishPayload.cooked_weight_g = 0
      }
    }

    // Время приёма — выбранное в строке времени (по умолчанию — округлённое
    // текущее или props.eatenAt), а не момент нажатия «Сохранить»
    const eatenAt = mealDateTimeIso(mealStartH.value, mealStartM.value)

    // Весь приём — блюдо и все ингредиенты — одним запросом в одной
    // транзакции (POST /diary/entries). Раньше это было до девяти запросов
    // подряд, и обрыв любого показывал «ошибку» при уже записанной половине.
    // client_id пакета и записей живут в состоянии окна: повторное «Сохранить»
    // после обрыва шлёт те же ключи, и сервер возвращает созданное, а не дубли.
    // Ингредиенты с нулевым весом (напр. сахарозаменитель 0 г) пропускаем —
    // бэкенд отклоняет weight_g=0.
    const items = localItems.value.filter(item => item.weight_g && item.weight_g > 0)
    for (const item of items) if (!item._client_id) item._client_id = uuid()
    const { data: batch } = await api.post('/diary/entries', {
      client_id: saveClientId,
      dish_id:   isUnmodifiedRepeat ? props.dishId : null,
      dish:      dishPayload,
      // Связь «ответ модели → что сохранил человек» для журнала распознаваний
      recognition_id: currentRecognitionId.value || null,
      // Правка: какие записи заменяет этот пакет (см. выше)
      replace_entry_ids: props.mode === 'edit' && props.entryIds.length > 0 ? props.entryIds : undefined,
      entries:   items.map((item, i) => ({
        client_id:    item._client_id,
        product_id:   item.product_id,
        product_name: item.name,
        weight_g:     item.weight_g,
        kcal:         item.kcal,
        protein:      item.protein,
        fat:          item.fat,
        carbs:        item.carbs,
        fiber:        item.fiber   ?? null,
        water_ml:     item.water   ?? null,
        photo_url:    i === 0 ? photoUrl : null,
        eaten_at:     eatenAt,
        source:       props.mode === 'text' ? 'chat' : props.mode === 'edit' ? 'edit' : props.mode === 'photo' ? (props.voice ? 'voice' : 'photo') : 'repeat',
        vitamins:     item._totalVitamins || item._noVitamins?.length
                        ? { ...(item._totalVitamins || {}), ...(item._noVitamins?.length ? { _no_vitamins: item._noVitamins } : {}) }
                        : null,
        weight_basis: item._grain?.basis || item._cooking?.basis || null,
        // Штуки и порции — как было введено; без единицы тройка пустая
        qty:          item._unit && item.qty > 0 ? item.qty : null,
        unit_name:    item._unit && item.qty > 0 ? item._unit.name : null,
        unit_g:       item._unit && item.qty > 0 ? item._unit.grams : null,
      })),
    }, { idempotent: true })
    const dishId = batch.dish_id
    added.push(...batch.entries)

    // Синхронизируем is_favorite только для новых photo/text блюд,
    // где пользователь мог переключить сердечко вручную.
    // Repeat (reuse) — is_favorite уже на оригинале.
    // Repeat (copy-on-write) — копия не наследует избранное.
    // Edit — не наследует избранное.
    if (dishId && !isUnmodifiedRepeat && !props.dishId && isFavorite.value) {
      try { await api.patch(`/diary/dishes/${dishId}/favorite`) } catch {}
    }
    // Теги — на только что созданное блюдо (новое или копия при правке)
    if (dishId && dishId !== props.dishId && dishTags.value.length) {
      try {
        const tags = await useFavTagsStore().setDishTags(dishId, dishTags.value)
        emit('tags-changed', { dishId, tags })
      } catch {}
    }

    // Сохраняем отредактированные рецепты в кэш (fire-and-forget, только если есть per100)
    // В portionMode сохраняем только item'ы с _ingredientsEdited (замена ингредиента вручную)
    {
      for (const item of localItems.value) {
        if (isPortionMode.value && !item._ingredientsEdited) continue
        const hasAnyPer100 = item.ingredients?.some(ing => ing.per100?.kcal > 0)
        if (item.ingredients?.length > 1 && hasAnyPer100) {
          const totalWeight = item.weight_g || item.ingredients.reduce((s, i) => s + (i.weight_g || 0), 0)
          api.post('/diary/recipe', {
            product_name: item.name,
            cooking_method: item.cooking_method || 'raw',
            ingredients: item.ingredients.map(ing => ({
              name: ing.name,
              weight_per_100g: totalWeight > 0 ? Math.round((ing.weight_g || 0) / totalWeight * 100 * 10) / 10 : 0,
              per100: ing.per100 || {},
              product_id: ing.product_id || null,
              db_name: ing.db_name || null,
              // POST /diary/recipe перезаписывает zoya_dishes.ingredients целиком,
              // поэтому пропущенное здесь поле не просто не сохраняется, а стирает
              // уже записанное — блюдо теряло раскладку сразу после создания.
              grain: ing._grain || null,
              cooking: ing._cooking || null,
            })),
          }).catch(err => console.error('Recipe cache save error:', err.response?.data || err.message))
        }
      }
    }

    // Прикрепляем dish_cooked_weight_g к entries для корректного отображения в MealGroup
    if (isPortionMode.value && portionWeight.value) {
      for (const entry of added) entry.dish_cooked_weight_g = portionWeight.value
    }

    // Прикрепляем is_favorite, dish_name и раскладку к entries
    // (POST /diary не возвращает их из JOIN)
    for (const entry of added) {
      if (isUnmodifiedRepeat) {
        entry.is_favorite = true
      } else if (props.mode === 'edit' || props.dishId) {
        // edit или модифицированный repeat — копия не наследует избранное
        entry.is_favorite = false
      } else {
        // новое блюдо (photo/text) — берём текущее значение сердечка
        entry.is_favorite = isFavorite.value
      }
      if (dishName.value) entry.dish_name = dishName.value
      // Состав блюда нужен блоку «откуда клетчатка»: он разворачивает позицию
      // до её ингредиентов. Без него первый — оптимистичный — рендер до
      // следующей загрузки дневника показывал вместо состава саму позицию:
      // под «Пастой с креветками и лимоном» строку «Паста с креветками»,
      // повторяющую итог, вместо макарон, лимона и чеснока.
      if (dishIngredients?.length) entry.dish_ingredients = dishIngredients
    }

    // Конец приёма отличается от серверного дефолта (+20 мин) — дописываем.
    // POST /diary сам ставит meal_end_at и не принимает его в теле.
    const defaultEnd = (mealStartH.value * 60 + mealStartM.value + 20) % 1440
    if (added.length && mealEndH.value * 60 + mealEndM.value !== defaultEnd) {
      try {
        await api.patch('/diary/group-time', {
          entry_ids: added.map(e => e.id),
          eaten_at: eatenAt,
          meal_end_at: mealDateTimeIso(mealEndH.value, mealEndM.value),
        })
      } catch (err) {
        console.error('Meal end update error:', err.message)
      }
    }

    // Повтор на будущие даты — только для новых записей: в edit-режиме
    // правило применяется сразу из попапа, здесь его трогать нельзя
    if (props.mode !== 'edit' && added.length && ruleHasAny(repeatRule.value)) {
      try {
        const rule = { ...repeatRule.value, anchor_date: effectiveAnchorDate(mealDate.value) }
        const { add_offsets, remove_ranges } = planRuleChange(null, rule, mealDate.value)
        if (add_offsets.length) {
          const { data: dup } = await api.post('/diary/duplicate', {
            entry_ids: added.map(e => e.id),
            rule,
            add_offsets,
            remove_ranges,
            not_before: todayStartIso(),
          })
          // Набор и правило записям проставил сервер уже ПОСЛЕ их создания.
          // Без этой дозаписи дневник до перезагрузки держит записи без
          // duplicate_*, и повторно открытое блюдо выглядит непродублированным.
          if (dup?.duplicate_group_id) {
            for (const e of added) {
              e.duplicate_group_id = dup.duplicate_group_id
              e.duplicate_rule = rule
            }
          }
          cacheClearFutureDiary(todayDateStr())
        }
      } catch (err) {
        console.error('Duplicate error:', err.response?.data?.error || err.message)
      }
    }

    track('food_saved', { items_count: added.length, source: props.mode })
    guide.journey('j_saved', { src: props.voice ? 'voice' : props.mode })
    saveClientId = uuid()
    if (draftable) clearDraft('meal')
    window.dispatchEvent(new Event('zoya:entry-saved'))
    emit('added', added, dishName.value)
    emit('close')
  } catch (err) {
    console.error('addAll error:', err.response?.status, err.response?.data, err.message)
    saveError.value = describeSaveError(err)
    // Обрыв или таймаут: окно остаётся с данными, отправка повторится сама
    // при возврате связи — тем же путём и с теми же ключами
    if (isNetworkFailure(err)) registerPendingSave(pendingSaveKey, () => addAll(force))
  } finally {
    addingAll.value = false
    if (slowSaveTimer) { clearTimeout(slowSaveTimer); slowSaveTimer = null }
    slowSave.value = false
  }
}
</script>

<style scoped>
/* Сетка иконок в блоке фото — как в карточке ленты (MealGroup.vue), только
   без отступа под пилюли: здесь их нет */
.icon-grid { display: grid; gap: 4px; padding: 14%; align-content: center; justify-content: center; align-items: center; justify-items: center; }
.icon-grid img { width: 100%; height: auto; aspect-ratio: 1; object-fit: contain; filter: drop-shadow(0 3px 4px rgba(0,0,0,.35)); }
.icon-grid.n1 { grid-template-columns: 42%; }
.icon-grid.n2 { grid-template-columns: 27% 27%; }
.icon-grid.n3, .icon-grid.n4 { grid-template-columns: 27% 27%; grid-auto-rows: min-content; }
.icon-grid.n3 img:first-child { grid-column: 1 / span 2; width: 50%; }
/* Высота листа.
 *
 * Две строки подряд — не опечатка. `dvh` учитывает свернувшуюся адресную
 * строку, а `vh` на мобильных браузерах больше видимой области; старые webview
 * про `dvh` не знают и возьмут первую. Так же сделано в ProductDetails.vue и на
 * экранах онбординга.
 *
 * Почему это важно именно здесь: лист прижат к низу (`items-end`), поэтому
 * лишняя высота уходит за ВЕРХНЮЮ кромку экрана — вместе с шапкой, где крестик.
 * Крестик при этом не «уезжает при прокрутке»: он лежит вне прокручиваемой
 * области, за кромку уходит всё окно целиком. Со `100vh` при длинном составе
 * закрыть блюдо было нечем, а содержимое пружинило, потому что прокручивать
 * уже некуда. */
.photo-sheet {
  max-height: 85vh;
  max-height: 85dvh;
  /* под системные кнопки Android во всех состояниях окна (style.css) */
  padding-bottom: var(--sheet-bottom, 0px);
}
/* Ниже .photo-sheet намеренно: специфичность та же, побеждает порядок */
.photo-sheet-expanded {
  max-height: 100vh;
  max-height: 100dvh;
}
.photo-sheet-loading {
  height: 85vh;
  height: 85dvh;
}

.pill-kcal    { background: #EE998C; border-radius: 8px; padding: 2px 8px; color: var(--ink); }
.pill-protein { background: #9FC2C1; border-radius: 8px; padding: 2px 8px; color: var(--ink); }
.pill-fat     { background: #EBC06D; border-radius: 8px; padding: 2px 8px; color: var(--ink); }
.pill-carbs   { background: #EEAD77; border-radius: 8px; padding: 2px 8px; color: var(--ink); }

.pill-fiber   { background: #A6B779; border-radius: 8px; padding: 2px 8px; color: var(--ink); }
.yellow-placeholder::placeholder {
  color: var(--ink-70);
}

.photo-content-appear {
  animation: fadeIn 300ms ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.hide-spin::-webkit-inner-spin-button,
.hide-spin::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.hide-spin { -moz-appearance: textfield; }

/* Эффект сканирования поверх фото */
.scan-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, transparent 0%, rgba(201,122,63,0.2) 50%, transparent 100%);
  background-size: 100% 30%;
  background-repeat: no-repeat;
  animation: scan 2.4s ease-in-out infinite;
}
@keyframes scan {
  0%   { background-position: 0 -30%; }
  50%  { background-position: 0 130%; }
  100% { background-position: 0 -30%; }
}

/* Угловые маркеры */
.scan-corner {
  position: absolute;
  width: 18px;
  height: 18px;
}

/* Crossfade для советов */
.tip-fade-enter-active,
.tip-fade-leave-active {
  transition: opacity 0.2s ease;
}
.tip-fade-enter-from,
.tip-fade-leave-to {
  opacity: 0;
}

/* Анимация появления мини-карточки ингредиента */
.ing-card-enter {
  animation: ingCardIn 250ms ease-out;
}
.ing-card-content {
  animation: ingContentIn 200ms ease-out 50ms both;
}
@keyframes ingCardIn {
  from { opacity: 0; box-shadow: none; transform: scale(0.98); }
  to   { opacity: 1; transform: scale(1); }
}
@keyframes ingContentIn {
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
}
</style>
